var $ = require("jquery");
require("slick-carousel");
import Swiper from "./plugins/swiper/swiper-bundle.min";
import LazyLoad from "./plugins/lazyload/lazyload.min";
import Accordion from "./plugins/accordion/accordion";
import Plyr from "./plugins/plyr/plyr";
import { gsap } from "./plugins/gsap/gsap.min.js";
import { ScrollTrigger } from "./plugins/gsap/ScrollTrigger.min.js";
import { ScrollToPlugin } from "./plugins/gsap/ScrollToPlugin.min.js";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

const ESCAPE_KEYCODE = 27;
const ENTER_KEYCODE = 13;

let isMenuOpen = false;
let isFilterOpen = false;
let isSortOpen = false;
let isCatOpen = false;
let isNewsletterModalOpen = false;
let lazyLoadInstance = null;

// Homepage loader functionality
const initHomepageLoader = () => {
  // Check if we're on the homepage using data attributes
  const isHomepage = document.body.getAttribute("data-page") === "index";

  if (isHomepage) {
    // Check if loader has been shown in this session
    const loaderShown = sessionStorage.getItem("homepageLoaderShown");

    if (!loaderShown) {
      // Add the loader-shown class to body
      document.body.classList.add("loader-shown");

      // Mark as shown in session storage
      sessionStorage.setItem("homepageLoaderShown", "true");

      // Add fade-out class after 2400ms (100ms before removing loader-shown)
      setTimeout(() => {
        document.body.classList.add("fade-out");
      }, 2400);

      // Remove both classes after 2500ms (100ms after fade-out starts)
      setTimeout(() => {
        document.body.classList.remove("loader-shown", "fade-out");
      }, 2500);
    }
  }
};

function removeClassByPrefix(el, prefix) {
  var regx = new RegExp("\\b" + prefix + ".*?\\b", "g");
  el.className = el.className.replace(regx, "");
  return el;
}

const showHtml = () => {
  const html = document.querySelector("html");

  if (html) html.style.visibility = "visible";
};

const enableDocumentScroll = () => {
  // scrollLock.enablePageScroll()
  document.body.style.overflow = "auto";
};

const disableDocumentScroll = () => {
  // scrollLock.disablePageScroll()
  document.body.style.overflow = "hidden";
};

const initPlyrForMainArticle = () => {
  const options = {
    controls: ["play", "progress", "mute", "volume"],
  };

  const controls = `
    <div class="plyr__controls">
    <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
    </button>
    <div class="plyr__progress">
        <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
        <span role="tooltip" class="plyr__tooltip">00:00</span>
    </div>
    <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
    <svg class="icon--pressed" role="presentation" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.38885 16V7" stroke="white"/>
        <path d="M14.3889 16V7" stroke="white"/>
        <path d="M9.38885 16V0" stroke="white"/>
        <rect y="17.0813" width="23.9993" height="1" transform="rotate(-45 0 17.0813)" fill="white"/>
    </svg>

        <svg class="icon--not-pressed" role="presentation" xmlns="http://www.w3.org/2000/svg" width="11" height="16" viewBox="0 0 11 16">
            <path transform="translate(.5 7)" style="fill:none;stroke:#fff" d="M0 9V0"/>
            <path data-name="Rule" transform="translate(10.5 7)" style="fill:none;stroke:#fff" d="M0 9V0"/>
            <path data-name="Rule" transform="translate(5.5)" style="fill:none;stroke:#fff" d="M0 16V0"/>
        </svg>

        <span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
    </button>
    <div class="plyr__volume">
        <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
    </div>
</div>
    `;

  const plyr = new Plyr("#article-vimeo-player", { controls });
};

const flashMessageForNewsletterSubscription = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const contactParam = urlParams.get("contact[tags]");
  const customerPostedParams = urlParams.get("customer_posted");

  // const wasContactFormSubmited = window.location.hash === '#contact_form' && contactParam === 'newsletter'
  const wasContactFormSubmited =
    contactParam === "newsletter" || customerPostedParams === "true";
  const modal = document.getElementById("newsletter-shadow-bg");
  const modalNewsletter = document.querySelector(
    ".newsletter.newsletter-modal"
  );
  const modalWrapper = document.getElementById("newsletter-wrapper");

  if (wasContactFormSubmited) {
    modal && modal.classList.add("active");
    modalNewsletter && modalNewsletter.classList.add("active");
    modalWrapper && modalWrapper.classList.add("has-been-submited");
    // disableDocumentScroll()
    isNewsletterModalOpen = false;
    setCookie("closedNewsletter=true");
    // clearTimeout(newsletterTimer)

    // check if it's not the success message
    if (
      modalNewsletter & !modalNewsletter.classList.contains("has-been-submited")
    ) {
      setTimeout(() => {
        // enableDocumentScroll()
        // closeNewsletterModal()
        modal && modal.classList.remove("active");
        modalNewsletter && modalNewsletter.classList.remove("active");
        modalWrapper && modalWrapper.classList.remove("has-been-submited");
        isNewsletterModalOpen = false;
      }, 3000);
    }
  }
};

// const removePreload = () => {
//     const preloadedItems = document.querySelectorAll('.preload')

//     setTimeout(() => {
//         preloadedItems.forEach((item, i) => {
//             // item.style.display = 'block'
//             item.style.removeProperty('display')
//         })
//     }, 300)
// }

const initAccordion = () => {
  const accordionElement = document.querySelector(".accordion-container");

  const options = {
    duration: 250,
  };

  if (accordionElement) {
    const accordion = new Accordion(".accordion-container", options);
  }
};

/**
 * Toggle header classes for init position
 */
// const headerSwitch = () => {
//   const container = document.querySelector(".header .container");
//   if (window.scrollY > 0) {
//     container.classList.remove("1366:py-20");
//     container.classList.add("1366:py-10");
//   } else {
//     container.classList.remove("1366:py-10");
//     container.classList.add("1366:py-20");
//   }
// };

const initLazyLoading = () => {
  lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    unobserve_entered: true,
    threshold: -100,
  });
};

const editionsNavigation = () => {
  const editionsLink = document.getElementById("editions-link");
  const editionsSection = document.getElementById("editions-section");

  let timeoutId;
  const timeoutLength = 500;

  function addClass() {
    editionsSection.classList.add("hovered");
  }

  function removeClass() {
    editionsSection.classList.remove("hovered");
  }

  editionsLink.addEventListener("mouseover", () => {
    addClass();
    clearTimeout(timeoutId);

    new LazyLoad({
      elements_selector: ".edition-lazy",
    });
  });

  editionsLink.addEventListener("mouseleave", () => {
    timeoutId = setTimeout(removeClass, timeoutLength); // Adjust the timeout duration as needed
  });

  editionsSection.addEventListener("mouseover", () => {
    addClass();
    clearTimeout(timeoutId);

    new LazyLoad({
      elements_selector: ".edition-lazy",
    });
  });

  editionsSection.addEventListener("mouseleave", () => {
    timeoutId = setTimeout(removeClass, timeoutLength); // Adjust the timeout duration as needed
  });
};

const toggleMenu = () => {
  const header = document.getElementById("header");
  const hamburger = document.getElementById("hamburger");
  const editions = document.getElementById("editions");
  const newsletter = document.querySelector(".newsletter");

  hamburger &&
    hamburger.addEventListener("click", () => {
      header && header.classList.toggle("menu-open");
      newsletter && newsletter.classList.toggle("menu-open");
      editions && editions.classList.remove("submenu-open");
      editions &&
        editions.parentElement.parentElement.classList.remove("submenu-open");
    });
};

const addToBagFromVariantSelector = () => {
  const buttons = document.querySelectorAll(".trigger-add");
  const addButton = document.querySelector(".product-form__submit");

  buttons &&
    buttons.forEach(function (button) {
      button.addEventListener("click", () => {
        addButton.click();
      });
    });
};

const openEditionsSubMenu = () => {
  // const editions = document.getElementById("editions");
  // editions && editions.classList.add("submenu-open");
  // editions &&
  //   editions.parentElement.parentElement.classList.add("submenu-open");
};

const editionsSubMenuClick = () => {
  // const editionsLink = document.getElementById("editions-link");
  // editionsLink &&
  //   editionsLink.addEventListener("click", (e) => {
  //     e.preventDefault();
  //     if (window.innerWidth <= 874) {
  //       $("#shop-link").hide();
  //       openEditionsSubMenu();
  //     }
  //   });
};

const toggleMobileShopAllMenu = () => {
  const shopLink = document.getElementById("shop-link-mobile");
  const shopSubmenu = document.getElementById("shop-all-submenu");
  const editionsLink = document.getElementById("editions-link-mobile");
  const editionsSubmenu = document.getElementById("editions-submenu");
  const collectionsLink = document.getElementById("collections-link-mobile");
  const collectionsSubmenu = document.getElementById("collections-submenu");

  shopLink &&
    shopLink.addEventListener("click", () => {
      shopLink.classList.toggle("open");
      shopSubmenu.classList.toggle("submenu-open");

      if (editionsLink && editionsSubmenu) {
        editionsLink.classList.remove("open");
        editionsSubmenu.classList.remove("submenu-open");
      }
      if (collectionsLink && collectionsSubmenu) {
        collectionsLink.classList.remove("open");
        collectionsSubmenu.classList.remove("submenu-open");
      }
    });
};

const toggleMobileEditionsMenu = () => {
  const editionsLink = document.getElementById("editions-link-mobile");
  const editionsSubmenu = document.getElementById("editions-submenu");
  const shopLink = document.getElementById("shop-link-mobile");
  const shopSubmenu = document.getElementById("shop-all-submenu");
  const collectionsLink = document.getElementById("collections-link-mobile");
  const collectionsSubmenu = document.getElementById("collections-submenu");

  editionsLink &&
    editionsLink.addEventListener("click", () => {
      editionsLink.classList.toggle("open");
      editionsSubmenu.classList.toggle("submenu-open");

      if (shopLink && shopSubmenu) {
        shopLink.classList.remove("open");
        shopSubmenu.classList.remove("submenu-open");
      }
      if (collectionsLink && collectionsSubmenu) {
        collectionsLink.classList.remove("open");
        collectionsSubmenu.classList.remove("submenu-open");
      }
    });
};

const toggleMobileCollectionsMenu = () => {
  const collectionsLink = document.getElementById("collections-link-mobile");
  const collectionsSubmenu = document.getElementById("collections-submenu");
  const shopLink = document.getElementById("shop-link-mobile");
  const shopSubmenu = document.getElementById("shop-all-submenu");
  const editionsLink = document.getElementById("editions-link-mobile");
  const editionsSubmenu = document.getElementById("editions-submenu");

  collectionsLink &&
    collectionsLink.addEventListener("click", () => {
      collectionsLink.classList.toggle("open");
      collectionsSubmenu.classList.toggle("submenu-open");

      if (shopLink && shopSubmenu) {
        shopLink.classList.remove("open");
        shopSubmenu.classList.remove("submenu-open");
      }
      if (editionsLink && editionsSubmenu) {
        editionsLink.classList.remove("open");
        editionsSubmenu.classList.remove("submenu-open");
      }
    });
};

const closeEditionSubMenu = () => {
  const editions = document.getElementById("editions");

  editions && editions.classList.remove("submenu-open");
  editions &&
    editions.parentElement.parentElement.classList.remove("submenu-open");

  $("#shop-link").show();
};

const editionSubMenuBackClick = () => {
  const back = document.getElementById("close-editions-submenu");

  back &&
    back.addEventListener("click", () => {
      closeEditionSubMenu();
    });
};

const removeDefaultFontFamily = () => {
  const item = document.querySelector(
    "#product-info-container .product-info .ac .ac-panel ul"
  );
  if (item) {
    item.style.fontFamily = "";
  }
};

const openShopSubMenu = () => {
  const shop = document.getElementById("shop");

  shop && shop.classList.add("submenu-open");
  shop && shop.parentElement.parentElement.classList.add("submenu-open");
};

// const shopSubMenuClick = () => {
//     const shopLink = document.getElementById('shop-link')
//
//     shopLink &&
//         shopLink.addEventListener('click', e => {
//             if (window.innerWidth <= 874) {
//                 e.preventDefault()
//                 openShopSubMenu()
//             }
//         })
// }

const closeShopSubMenu = () => {
  const shop = document.getElementById("shop");

  shop && shop.classList.remove("submenu-open");
  shop && shop.parentElement.parentElement.classList.remove("submenu-open");
};

// const shopSubMenuBackClick = () => {
//     const back = document.getElementById('close-shop-submenu')
//
//     back &&
//         back.addEventListener('click', () => {
//             closeShopSubMenu()
//         })
// }

const openSearchInput = () => {
  const search = document.getElementById("search");
  const input = document.getElementById("search-input");
  const ba = document.querySelector(".ba-link");

  search &&
    search.addEventListener("click", (e) => {
      e.preventDefault();
      search.classList.add("input-open");
      if (ba) {
        ba.classList.add("hide");
      }
      isMenuOpen = true;
      // Try immediate focus first
      if (input) {
        // Try to focus immediately
        input.focus();

        // If that doesn't work, try with a delay after CSS transition completes
        if (document.activeElement !== input) {
          setTimeout(() => {
            // Try multiple focus methods
            input.focus();

            // If still not focused, try clicking first
            if (document.activeElement !== input) {
              input.click();
              input.focus();
            }
          }, 450); // Wait for 400ms CSS transition + 50ms buffer
        }
      } else {
      }
    });
};

const closeSearchInput = () => {
  const search = document.getElementById("search");
  const ba = document.querySelector(".ba-link");

  search && search.classList.remove("input-open");
  if (ba) {
    ba.classList.remove("hide");
  }
  isMenuOpen = false;
};

const initHomepageSwiper = () => {
  const options = {
    loop: true,
    preloadImages: true,
    lazy: false,
    slidesPerView: 1.1,
    spaceBetween: 10,
    centeredSlides: true,
    slideToClickedSlide: true,
    breakpoints: {
      640: {
        spaceBetween: 65,
        slidesPerView: 2,
      },
      768: {
        spaceBetween: 50,
        slidesPerView: 1.68,
      },
      1280: {
        spaceBetween: 125,
        slidesPerView: 2,
      },
      1920: {
        spaceBetween: 150,
        slidesPerView: 2.15,
      },
    },
    speed: 500,
  };

  const swiper = new Swiper("#swiper-homepage", options);

  // CUSTOM NAVIGATION
  const prev = document.querySelector(".custom-button.prev");
  const next = document.querySelector(".custom-button.next");

  prev &&
    prev.addEventListener("click", () => {
      swiper.slidePrev();
    });

  prev &&
    prev.addEventListener("touchstart", () => {
      swiper.slidePrev();
    });

  next &&
    next.addEventListener("click", () => {
      swiper.slideNext();
    });
};

const toggleFilters = () => {
  const button = document.getElementById("filter-toggle");
  const filters = document.getElementById("FacetsWrapperDesktop");

  button &&
    button.addEventListener("click", () => {
      if (isSortOpen) {
        closeSort();

        setTimeout(() => {
          button.classList.toggle("open");
          filters.classList.toggle("visible");

          if (Array.from(filters.classList).includes("visible"))
            isFilterOpen = true;
          else isFilterOpen = false;
        }, 400);
      } else if (isCatOpen) {
        closeCat();

        setTimeout(() => {
          button.classList.toggle("open");
          filters.classList.toggle("visible");

          if (Array.from(filters.classList).includes("visible"))
            isFilterOpen = true;
          else isFilterOpen = false;
        }, 400);
      } else {
        button.classList.toggle("open");
        filters.classList.toggle("visible");

        if (Array.from(filters.classList).includes("visible"))
          isFilterOpen = true;
        else isFilterOpen = false;
      }
    });
};

const openFilters = () => {
  const button = document.getElementById("filter-toggle");
  const filters = document.getElementById("FacetsWrapperDesktop");

  closeSort();
  closeCat();
  button.classList.toggle("open");
  filters.classList.toggle("visible");
};

const openFiltersIfQueryHasFopen = () => {
  const hash = window.location.hash;

  if (hash === "#fopen") {
    openFilters();
  }
};

const closeFilters = () => {
  const button = document.getElementById("filter-toggle");
  const filters = document.getElementById("FacetsWrapperDesktop");

  button && button.classList.remove("open");
  filters && filters.classList.remove("visible");

  isFilterOpen = false;
};

const toggleSort = () => {
  const button = document.getElementById("sort-toggle");
  const sort = document.getElementById("sort-panel");
  const activeFilters = document.querySelector(
    ".active-facets.active-facets-desktop"
  );
  const lastSortItem = document.querySelector(
    "#sort-header ~ div.sort-item:nth-child(4)"
  );

  button &&
    button.addEventListener("click", () => {
      if (isFilterOpen) {
        closeFilters();

        setTimeout(() => {
          button.classList.toggle("open");
          sort.classList.toggle("visible");
          if (activeFilters.children.length > 1)
            lastSortItem && lastSortItem.classList.add("active");
          showShadowBackgroundOnSortClick();

          if (Array.from(sort.classList).includes("visible")) isSortOpen = true;
          else isSortOpen = false;
        }, 400);
      } else if (isCatOpen) {
        closeFilters();

        setTimeout(() => {
          button.classList.toggle("open");
          sort.classList.toggle("visible");
          if (activeFilters.children.length > 1)
            lastSortItem && lastSortItem.classList.add("active");
          showShadowBackgroundOnSortClick();

          if (Array.from(sort.classList).includes("visible")) isSortOpen = true;
          else isSortOpen = false;
        }, 400);
      } else {
        button.classList.toggle("open");
        sort.classList.toggle("visible");
        if (activeFilters.children.length > 1)
          lastSortItem && lastSortItem.classList.add("active");
        showShadowBackgroundOnSortClick();

        if (Array.from(sort.classList).includes("visible")) isSortOpen = true;
        else isSortOpen = false;
      }
    });
};

const toggleCat = () => {
  const button = document.getElementById("cat-toggle");
  const cat = document.getElementById("cat-panel");
  const activeFilters = document.querySelector(
    ".active-facets.active-facets-desktop"
  );
  const lastCatItem = document.querySelector(
    "#cat-header ~ div.cat-item:nth-child(4)"
  );

  button &&
    button.addEventListener("click", () => {
      if (isFilterOpen) {
        closeFilters();

        setTimeout(() => {
          button.classList.toggle("open");
          cat.classList.toggle("visible");
          if (activeFilters.children.length > 1)
            lastCatItem && lastCatItem.classList.add("active");
          showShadowBackgroundOnCatClick();

          if (Array.from(cat.classList).includes("visible")) isCatOpen = true;
          else isCatOpen = false;
        }, 400);
      } else if (isSortOpen) {
        closeSort();

        setTimeout(() => {
          button.classList.toggle("open");
          cat.classList.toggle("visible");
          if (activeFilters.children.length > 1)
            lastCatItem && lastCatItem.classList.add("active");
          showShadowBackgroundOnCatClick();

          if (Array.from(cat.classList).includes("visible")) isCatOpen = true;
          else isCatOpen = false;
        }, 400);
      } else {
        button.classList.toggle("open");
        cat.classList.toggle("visible");
        if (activeFilters.children.length > 1)
          lastCatItem && lastCatItem.classList.add("active");
        showShadowBackgroundOnCatClick();

        if (Array.from(cat.classList).includes("visible")) isCatOpen = true;
        else isCatOpen = false;
      }
    });
};

const checkIfPdpNavAsReachedBottom = () => {
  const main = document.querySelector('[id*="MainProduct-template"]');
  const bottom = main && main.getBoundingClientRect().bottom;
  const backToTopBtn = document.querySelector('[data-component="back-to-top"]');
  const nav = document.querySelector(".product.product-nav-wrapper");

  if (window.innerHeight > bottom) {
    nav && nav.classList.add("reached-bottom");
    backToTopBtn && backToTopBtn.classList.remove("translated");
  } else {
    nav && nav.classList.remove("reached-bottom");
    backToTopBtn && backToTopBtn.classList.add("translated");
  }
};

const hpBannerCheck = () => {
  const el_after_banner = document.querySelector(".shop-bar");
  const el_after_banner_top =
    el_after_banner && el_after_banner.getBoundingClientRect().top;

  if (el_after_banner_top >= 50) {
    document.querySelector("header").classList.add("hp-banner");
  } else {
    document.querySelector("header").classList.remove("hp-banner");
  }

  // hp first banner
  const el_after_banner_2 = document.querySelector("main section:nth-child(1)");
  const el_after_banner_top_2 =
    el_after_banner_2 && el_after_banner_2.getBoundingClientRect().bottom;
  const el_1 = document.querySelector(".homepage-cta-first");
  const el_2 = document.querySelector("#video-btn");

  const newsletterModal = document.querySelector(".newsletter.active");

  if (window.innerHeight > el_after_banner_top_2) {
    // el_1 && el_1.classList.remove("fixed", "bottom-auto");
    el_2 && el_2.classList.remove("fixed", "bottom-auto");
    // el_1 && el_1.classList.add("absolute", "top-auto", "bottom-0");
    el_2 && el_2.classList.add("absolute", "top-auto", "bottom-0");

    newsletterModal && newsletterModal.classList.remove("banner");
  } else if (window.innerHeight < el_after_banner_top_2) {
    // el_1 && el_1.classList.remove("absolute", "top-auto", "bottom-0");
    el_2 && el_2.classList.remove("absolute", "top-auto", "bottom-0");
    // el_1 && el_1.classList.add("fixed", "bottom-auto");
    el_2 && el_2.classList.add("fixed", "bottom-auto");

    newsletterModal && newsletterModal.classList.add("banner");
  }
};

const closeSort = () => {
  const button = document.getElementById("sort-toggle");
  const sort = document.getElementById("sort-panel");
  const lastSortItem = document.querySelector(
    "#sort-header ~ div.sort-item:nth-child(4)"
  );
  const shadow = document.getElementById("sort-shadow-bg");

  button && button.classList.remove("open");
  sort && sort.classList.remove("visible");
  lastSortItem && lastSortItem.classList.remove("active");
  shadow && shadow.classList.remove("visible");

  isSortOpen = false;
};

const closeSortMenuOnItemClick = () => {
  const sortItems = document.querySelectorAll(".sort-item");

  sortItems &&
    sortItems.forEach((item) => {
      item.addEventListener("click", () => {
        setTimeout(() => {
          closeSort();
          closeShadow();
        }, 200);
      });
    });
};

const closeCat = () => {
  const button = document.getElementById("cat-toggle");
  const cat = document.getElementById("cat-panel");
  const lastCatItem = document.querySelector(
    "#cat-header ~ div.cat-item:nth-child(4)"
  );
  const shadow = document.getElementById("cat-shadow-bg");

  button && button.classList.remove("open");
  cat && cat.classList.remove("visible");
  lastCatItem && lastCatItem.classList.remove("active");
  shadow && shadow.classList.remove("visible");

  isCatOpen = false;
};

const closeCatMenuOnItemClick = () => {
  const catItems = document.querySelectorAll(".cat-item");

  catItems &&
    catItems.forEach((item) => {
      item.addEventListener("click", () => {
        setTimeout(() => {
          closeCat();
          closeShadow();
        }, 200);
      });
    });
};

const closeShadow = () => {
  const shadow = document.getElementById("shadow-bg");
  const sortShadow = document.getElementById("sort-shadow-bg");
  const catShadow = document.getElementById("cat-shadow-bg");

  shadow && shadow.classList.remove("visible");
  sortShadow && sortShadow.classList.remove("visible");
  catShadow && catShadow.classList.remove("visible");
};

const closeOnShadowClick = () => {
  const shadow = document.getElementById("shadow-bg");
  const sortShadow = document.getElementById("sort-shadow-bg");
  const catShadow = document.getElementById("cat-shadow-bg");

  shadow &&
    shadow.addEventListener("click", () => {
      shadow.classList.remove("visible");
      closeFilters();
      closeSort();
      closeCat();
    });

  sortShadow &&
    sortShadow.addEventListener("click", () => {
      sortShadow.classList.remove("visible");
      closeFilters();
      closeSort();
      closeCat();
    });

  catShadow &&
    catShadow.addEventListener("click", () => {
      catShadow.classList.remove("visible");
      closeFilters();
      closeSort();
      closeCat();
    });
};

const closeFiltersOnCloseClick = () => {
  const close = document.getElementById("close-filter-mobile");

  close &&
    close.addEventListener("click", (e) => {
      e.preventDefault();
      closeFilters();
    });
};

const toggleFacetsAccordion = () => {
  const facetsSummary = document.querySelectorAll(
    "#FacetsWrapperDesktop .facets__summary"
  );
  let hasOpenItems = false;

  facetsSummary &&
    facetsSummary.forEach((facet) => {
      facet.addEventListener("click", (e) => {
        facetsSummary.forEach((_facet) => {
          if (_facet != facet) {
            if (Array.from(_facet.parentElement.classList).includes("is-open"))
              hasOpenItems = true;

            _facet.parentElement.classList.remove("is-open");
          }
        });

        if (hasOpenItems) {
          setTimeout(() => {
            facet.parentElement.classList.toggle("is-open");
          }, 400);
        } else {
          facet.parentElement.classList.toggle("is-open");
        }
      });
    });
};

const showShadowBackgroundOnSortClick = () => {
  const shadow = document.getElementById("sort-shadow-bg");
  const sort = document.getElementById("sort-panel");
  const viewportWidth = window.innerWidth;

  if (viewportWidth < 874) {
    if (Array.from(sort.classList).includes("visible")) {
      shadow.classList.add("visible");
    }
  }
};

const showShadowBackgroundOnCatClick = () => {
  const shadow = document.getElementById("cat-shadow-bg");
  const cat = document.getElementById("cat-panel");
  const viewportWidth = window.innerWidth;

  if (viewportWidth < 874) {
    if (Array.from(cat.classList).includes("visible")) {
      shadow.classList.add("visible");
    }
  }
};

const closeSortOnCloseClick = () => {
  const close = document.getElementById("close-sort-mobile");

  close &&
    close.addEventListener("click", (e) => {
      e.preventDefault();
      closeShadow();
      closeSort();
    });
};

const closeCatOnCloseClick = () => {
  const close = document.getElementById("close-cat-mobile");

  close &&
    close.addEventListener("click", (e) => {
      e.preventDefault();
      closeShadow();
      closeCat();
    });
};

const applyFilters = () => {
  // PROBABLY WILL ONLY CLOSE FILTERS MENU
  closeFilters();
};

const applySort = () => {
  // PROBABLY WILL ONLY CLOSE SORT MENU
  closeSort();
};

const applyCat = () => {
  // PROBABLY WILL ONLY CLOSE CAT MENU
  closeCat();
};

const sortListing = () => {
  const li = document.querySelectorAll("#product-grid .grid__item");
  const search_li = document.querySelectorAll(
    '[data-page="search"] .grid__item'
  );
  const params = window.location.href.split("?");

  if (params.length > 1 && params[1] !== "") {
    li.forEach((item) => {
      if (item.classList.contains("sorted-li")) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  if (params.length > 1 && params[1] !== "") {
    search_li.forEach((item) => {
      item.style.display = "block";
    });
  }
};

const applySortOnButtonClick = () => {
  const applyButton = document.getElementById("apply-sort-button");

  applyButton &&
    applyButton.addEventListener("click", (e) => {
      e.preventDefault();
      applySort();
      closeShadow();
    });
};

const applyCatOnButtonClick = () => {
  const applyButton = document.getElementById("apply-cat-button");

  applyButton &&
    applyButton.addEventListener("click", (e) => {
      e.preventDefault();
      applyCat();
      closeShadow();
    });
};

const applyFiltersOnButtonClick = () => {
  const applyButton = document.getElementById("apply-filters-button");

  applyButton &&
    applyButton.addEventListener("click", (e) => {
      e.preventDefault();
      applyFilters();
      closeFilters();
    });
};

const removeActiveContents = () => {
  const contents = document.querySelectorAll("#legal .text-content");

  contents &&
    contents.forEach((content) => {
      content.classList.remove("active");
    });
};

const removeActiveTabs = () => {
  const tabs = document.querySelectorAll(".tab");

  tabs &&
    tabs.forEach((tab) => {
      tab.classList.remove("active");
    });
};

const activeLegalTab = () => {
  const tabs = document.querySelectorAll(".tab");
  const contents = document.querySelectorAll("#legal .text-content");

  tabs &&
    tabs.forEach((tab, i) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        removeActiveContents();
        removeActiveTabs();

        tab.classList.add("active");
        contents[i].classList.add("active");
      });
    });
};

// Newsletter Subscribe Pop-Up Functionality
const checkNewsletterClosed = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const customerPostedParams = urlParams.get("customer_posted");

  // const wasContactFormSubmited = window.location.hash === '#contact_form' && contactParam === 'newsletter'
  const wasContactFormSubmited = customerPostedParams === "true";
  // Collect: changing cookie to session storage
  // const newsletterOpened = isCookieSet("closedNewsletter");
  const newsletterOpened = sessionStorage.getItem("closedNewsletter");
  const modal = document.querySelector(".newsletter-modal");
  const buttonClose = document.getElementById("newsletter-close-button");
  const newsletterModal = document.querySelector(".newsletter-modal");

  const main = document.querySelector("main");
  const bottom = main && main.getBoundingClientRect().bottom;

  if (window.innerHeight > bottom) {
    newsletterModal && newsletterModal.classList.add("bottom");
  } else {
    newsletterModal && newsletterModal.classList.remove("bottom");
  }

  if (!newsletterOpened && !wasContactFormSubmited) {
    const body_el = document.querySelector("body");
    const distanceToTop = body_el.getBoundingClientRect().top;

    var newsletterTimer = setTimeout(() => {
      if (!newsletterOpened) {
        modal && modal.classList.add("active");
        isNewsletterModalOpen = true;
      }
    }, 1000);

    if (distanceToTop < -1500) {
      modal && modal.classList.add("active");
      isNewsletterModalOpen = true;
    }
  }

  buttonClose &&
    buttonClose.addEventListener("click", () => {
      // Collect: changing cookie to session storage
      // setCookie("closedNewsletter=true");
      sessionStorage.setItem("closedNewsletter", "true");
      closeNewsletterModal();
      clearTimeout(newsletterTimer);
    });
};

const openNewsletterModal = () => {
  const subscribeButton = document.getElementById("subscribe-button");
  const subscribeButtonBanner = document.getElementById(
    "subscribe-button-banner"
  );
  const modal = document.querySelector(".newsletter-modal");

  subscribeButton &&
    subscribeButton.addEventListener("click", (e) => {
      e.preventDefault();
      modal && modal.classList.add("active");
      isNewsletterModalOpen = true;
    });

  subscribeButtonBanner &&
    subscribeButtonBanner.addEventListener("click", (e) => {
      e.preventDefault();
      modal && modal.classList.add("active");
      isNewsletterModalOpen = true;
    });
};

const closeNewsletterModal = () => {
  const modal = document.querySelector(".newsletter-modal");

  modal && modal.classList.remove("active");
  // enableDocumentScroll()
  isNewsletterModalOpen = false;
};

const closeNewsLetterOnCloseClick = () => {
  const closeButton = document.getElementById("newsletter-close-button");

  closeButton &&
    closeButton.addEventListener("click", () => {
      closeNewsletterModal();
    });
};

// End Newsletter Subscribe Pop-Up Functionality

const setLegendFromProductVariantSelected = () => {
  const options = document.querySelectorAll(
    '.pdp-variant .product-form__input input[type="radio"]'
  );

  options &&
    options.forEach((option, i) => {
      // SHOW SOLD OUT LABEL IN SIZE
      setTimeout(() => {
        if (option.checked && option.name == "Color") {
          let legend_1 = option.nextElementSibling.innerText;

          if (
            document.querySelector(
              '.sold-out-label[data-color="' + legend_1 + '"]'
            )
          ) {
            const sold_out_label_1 = document.querySelector(
              '.sold-out-label[data-color="' + legend_1 + '"]'
            );
            if (sold_out_label_1) {
              sold_out_label_1.parentElement.classList.add("sold-out");
              sold_out_label_1.classList.remove("hidden");
            }
          }

          // HEADER TEXT COLOR
          let header = document.getElementById("header");
          removeClassByPrefix(header, "variant-color-");
          header.classList.add(
            "variant-color-" +
              option.value.split(" ").join("-").toLowerCase() +
              ""
          );

          Array.from(document.querySelectorAll("[data-variant-color]")).forEach(
            function (el) {
              el.classList.add("hidden");
            }
          );
          Array.from(
            document.querySelectorAll(
              '[data-variant-color="' + option.value + '"]'
            )
          ).forEach(function (el) {
            el.classList.remove("hidden");
          });
          Array.from(document.querySelectorAll("[data-variant-hero]")).forEach(
            function (el) {
              el.classList.add("hidden");
            }
          );
          Array.from(
            document.querySelectorAll(
              '[data-variant-hero="' + option.value + '"]'
            )
          ).forEach(function (el) {
            el.classList.remove("hidden");
          });
        }
      }, 500);

      option.addEventListener("change", () => {
        let legend = "";

        if (option.checked) {
          // Handle size variants differently - don't modify their content
          if (option.name === "Size") {
            // For size variants, update visual state and skip legend logic
            // Remove current-variant class from all size labels
            const allSizeLabels = document.querySelectorAll(
              ".size-variant-label"
            );
            allSizeLabels.forEach((label) =>
              label.classList.remove("current-variant")
            );

            // Add current-variant class to the selected size label
            option.nextElementSibling.classList.add("current-variant");
          } else {
            // For non-size variants (like Color), use the original logic
            // SELECTS <p class="variant-option"> <span></span> </p> ABOVE
            const variantOption =
              option.parentElement.parentElement.parentElement.firstElementChild
                .firstElementChild;

            // GETS THE LABEL VALUE OF THE SELECTED OPTION
            legend = option.nextElementSibling.innerText;
            if (legend.includes("—")) {
              legend = legend.substring(0, legend.indexOf("—"));
            }
          }

          // SHOW/HIDE SOLD OUT LABEL IN SIZE
          if (option.name == "Color") {
            Array.from(document.querySelectorAll(".sold-out-label")).forEach(
              function (el) {
                el.classList.add("hidden");
                el.parentElement.classList.remove("sold-out");
              }
            );

            // if (sold_out_label) {
            //
            //   if ((sold_out_label = document.querySelector('.sold-out-label[data-color="' + legend.toLowerCase() + '"]'))) {
            //       const sold_out_label = document.querySelector('.sold-out-label[data-color="' + legend.toLowerCase() + '"]')
            //       sold_out_label.parentElement.classList.add('sold-out')
            //       sold_out_label.classList.remove('hidden')
            //   }
            // }

            // HEADER TEXT COLOR
            let header = document.getElementById("header");
            removeClassByPrefix(header, "variant-color-");
            header.classList.add(
              "variant-color-" +
                option.value.split(" ").join("-").toLowerCase() +
                ""
            );

            Array.from(
              document.querySelectorAll("[data-variant-color]")
            ).forEach(function (el) {
              el.classList.add("hidden");
            });
            Array.from(
              document.querySelectorAll(
                '[data-variant-color="' + option.value + '"]'
              )
            ).forEach(function (el) {
              el.classList.remove("hidden");
            });
            Array.from(
              document.querySelectorAll("[data-variant-color]")
            ).forEach(function (el) {
              el.classList.add("hidden-section");
            });
            Array.from(
              document.querySelectorAll(
                '[data-variant-color="' + option.value + '"]'
              )
            ).forEach(function (el) {
              el.classList.remove("hidden-section");
            });
            Array.from(
              document.querySelectorAll("[data-variant-hero]")
            ).forEach(function (el) {
              el.classList.add("hidden");
            });
            Array.from(
              document.querySelectorAll(
                '[data-variant-hero="' + option.value + '"]'
              )
            ).forEach(function (el) {
              el.classList.remove("hidden");
            });

            Array.from(
              document.querySelectorAll(
                '[data-variant-hero="' + option.value + '"]'
              )
            ).forEach(function (el) {
              el.classList.remove("hidden");
            });

            // zoom images
            Array.from(
              document.querySelectorAll("[data-variant-color-zoom]")
            ).forEach(function (el) {
              el.classList.add("hidden");
            });
            Array.from(
              document.querySelectorAll(
                '[data-variant-color-zoom="' + option.value + '"]'
              )
            ).forEach(function (el) {
              el.classList.remove("hidden");
            });
          }

          // POPULATES THE <p class="variant-option"> <span></span> </p> ABOVE WITH THE VALUE OF THE SELECTED OPTION
          // Only modify variantOption for non-size variants
          if (option.name !== "Size" && variantOption) {
            variantOption.innerHTML = `${legend} <svg class="ml-4" xmlns="http://www.w3.org/2000/svg" width="11.804" height="6.608" viewBox="0 0 11.804 6.608">
                      <path d="m1996.926-8646.5 5.548 5.548 5.548-5.548" transform="translate(-1996.573 8646.854)" style="fill:none;stroke:#000"/>
                    </svg>`;
          }
        }

        // PLAY HERO VIDEO
        Array.from(document.querySelectorAll("[data-variant-hero]")).forEach(
          function (el) {
            if (
              el.firstChild.nextSibling.getElementsByTagName("video").length
            ) {
              setTimeout(() => {
                el.firstChild.nextSibling.pause();
              }, 100);
            }
          }
        );
        Array.from(
          document.querySelectorAll(
            '[data-variant-hero="' + option.value + '"]'
          )
        ).forEach(function (el) {
          if (el.firstChild.nextSibling.getElementsByTagName("video").length) {
            setTimeout(() => {
              el.firstChild.nextSibling.play();
            }, 100);
          }
        });

        let hero_video = document.querySelector("#video-banner:not(.hidden)");
        if (hero_video) {
          setTimeout(() => {
            hero_video.firstChild.nextSibling.play();
          }, 100);
        }
        // location.reload()

        closeVariantOptionsMenu();
      });
    });
};

const setLegendFromProductVariantSelectedGift = () => {
  const options = document.querySelectorAll(
    '.gift-form-wrapper fieldset input[type="radio"]'
  );
  const labels = document.querySelectorAll(".gift-form-wrapper fieldset label");

  options &&
    options.forEach((option, i) => {
      option.addEventListener("change", () => {
        labels &&
          labels.forEach((label, i) => {
            label.classList.remove("active");
          });

        if (option.checked) {
          option.nextElementSibling.classList.add("active");
        }

        setTimeout(() => {
          location.reload();
        }, 100);
      });
    });
};

const toggleVariantOptionsMenu = () => {
  const variantOptions = document.querySelectorAll(".pdp-nav .variant-option");
  const header = document.querySelector("header");

  variantOptions &&
    variantOptions.forEach((option, index) => {
      option.addEventListener("click", () => {
        // SHOW SOLD OUT LABEL IN SIZE
        setTimeout(() => {
          if (option.checked && option.name == "Color") {
            let legend_2 = option.nextElementSibling.innerText;
            const sold_out_label_2 = document.querySelector(
              '.sold-out-label[data-color="' + legend_2 + '"]'
            );
            sold_out_label_2.parentElement.classList.add("sold-out");
            sold_out_label_2.classList.remove("hidden");
          }
        }, 500);

        // remove active from opened options
        variantOptions.forEach((_option, i) => {
          if (i !== index) {
            _option.classList.remove("active");
            setTimeout(() => {
              _option.parentElement.classList.remove("active");
            }, 400);
          }
        });

        //header.classList.toggle('fade-behind')
        option.classList.toggle("active");
        option.parentElement.classList.toggle("active");

        let vw = window.innerWidth;

        if (vw < 768) {
          if (option.classList.contains("active")) {
            // disableDocumentScroll()
          } else {
            // enableDocumentScroll()
          }
        }
      });
    });
};

const closeVariantOptionsMenu = () => {
  const variantOptions = document.querySelectorAll(".pdp-nav .variant-option");

  variantOptions &&
    variantOptions.forEach((option) => {
      option.classList.remove("active");
      option.parentElement.classList.remove("active");
      setTimeout(() => {}, 400);
    });

  // enableDocumentScroll()
};

const closeVariantOptionsMenuIfOptionIsSelected = () => {
  const options = document.querySelectorAll(".pdp-variant fieldset > div");

  options &&
    options.forEach((option) => {
      option.addEventListener("click", () => {
        const input = option.firstElementChild;

        if (input.checked) {
          closeVariantOptionsMenu();
        }
      });
    });

  // enableDocumentScroll()
};

const closeVariantOptionsMenuOnOutClick = () => {
  const fieldsets = document.querySelectorAll(".pdp-variant fieldset");

  fieldsets &&
    fieldsets.forEach((fieldset) => {
      fieldset.addEventListener("click", (e) => {
        if (e.target !== fieldset) {
          closeVariantOptionsMenu();
        }
      });
    });

  // enableDocumentScroll()
};

const openProductMediaModal = () => {
  const productMedias = document.querySelectorAll(".product__media-item");
  const modal = document.querySelector(".product-media-modal.media-modal");
  const gallery = document.querySelector(
    ".product-media-modal.media-modal .product-media-modal__content"
  );
  const images = gallery && Array.from(gallery.children);

  let isFirstLoad = true;

  // images &&
  //   images.forEach((image) => {
  //     if (image.querySelector("button")) {
  //       isFirstLoad && image.querySelector("button").click();
  //       image.querySelector("video").setAttribute("loop", "true");
  //       image.querySelector("video").removeAttribute("controls");
  //       image.querySelector("video").play();

  //       isFirstLoad = false;
  //     }
  //   });

  images &&
    images.forEach((image) => {
      const button = image.querySelector("button");
      const video = image.querySelector("video");

      if (button) {
        if (isFirstLoad) {
          button.click();
        }
      }

      if (video) {
        video.setAttribute("loop", "true");
        video.removeAttribute("controls");
        video.play();
      }

      isFirstLoad = false;
    });

  productMedias &&
    productMedias.forEach((media) => {
      if (media.querySelector("video")) {
        media.querySelector("video").play();
      }
    });

  productMedias &&
    productMedias.forEach((media) => {
      media.addEventListener("click", () => {
        disableDocumentScroll();
        modal && modal.classList.add("is-visible");

        setTimeout(() => {
          const modalVideos = modal.querySelectorAll("video");
          modalVideos.forEach((modalVideo) => {
            modalVideo.play();
          });
        }, 50); // Small delay to ensure the modal is visible

        if (media.querySelector("video")) {
          media.querySelector("video").play();
        }

        const strArray = media.dataset.mediaId.split("-");
        const id = strArray[strArray.length - 1];

        // images &&
        //   images.forEach((image) => {
        //     if (image.querySelector("button")) {
        //       isFirstLoad && image.querySelector("button").click();
        //       image.querySelector("video").setAttribute("loop", "true");
        //       image.querySelector("video").removeAttribute("controls");
        //       image.querySelector("video").play();

        //       isFirstLoad = false;
        //     }

        //     const dataId = image.dataset.mediaId;
        //     const topOfImage = image.getBoundingClientRect().top;

        //     if (dataId == id) {
        //       gallery && gallery.scrollTo(0, topOfImage);
        //     }
        //   });

        images &&
          images.forEach((image) => {
            const button = image.querySelector("button");
            const video = image.querySelector("video");

            if (button) {
              if (isFirstLoad) {
                button.click();
              }
            }

            if (video) {
              video.setAttribute("loop", "true");
              video.removeAttribute("controls");
              video.play();
            }

            isFirstLoad = false;

            const dataId = image.dataset.mediaId;
            const topOfImage = image.getBoundingClientRect().top;

            if (dataId == id) {
              gallery && gallery.scrollTo(0, topOfImage);
            }
          });
      });
    });
};

const closeProductMediaModal = () => {
  const modal = document.querySelector(".product-media-modal.media-modal");
  const gallery = document.querySelector(
    ".product-media-modal.media-modal .product-media-modal__content"
  );
  const productMedias = document.querySelectorAll(".product__media-item");

  productMedias &&
    productMedias.forEach((media) => {
      if (media.querySelector("video")) {
        media.querySelector("video").play();
      }
    });

  if (gallery) {
    setTimeout(() => {
      gallery.scrollTo(0, 0);
    }, 400);
  }

  modal && modal.classList.remove("is-visible");
  enableDocumentScroll();
};

const closeProductMediaModalOnButtonClick = () => {
  const button = document.querySelector(".product-media-modal__toggle");

  button &&
    button.addEventListener("click", () => {
      document.body.classList.remove("product-modal-active");
      closeProductMediaModal();
    });
};

const closeVariantsOnShadowClick = () => {
  const shadowBackground = document.querySelectorAll(
    ".variant-modal-shadow-bg"
  );
  const header = document.querySelector("header");

  shadowBackground &&
    shadowBackground.forEach((element) => {
      element.addEventListener("click", () => {
        closeVariantOptionsMenu();
        //header.classList.toggle('fade-behind')
      });
    });
};

const closeVariantsOnButtonClick = () => {
  const button = document.querySelectorAll(".close-variant");
  const header = document.querySelector("header");

  button &&
    button.forEach((element) => {
      element.addEventListener("click", () => {
        closeVariantOptionsMenu();
        //header.classList.toggle('fade-behind')
      });
    });
};

const toggleSizeGuideTable = () => {
  const tabs = document.querySelectorAll(".sizeguide-tab");
  const tables = document.querySelectorAll(".sizeguide-table");

  tabs &&
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        hideSizeGuideTables();

        tab.classList.add("active");
        tables && tables[index].classList.add("active");
      });
    });
};

const hideSizeGuideTables = () => {
  const tabs = document.querySelectorAll(".sizeguide-tab");
  const tables = document.querySelectorAll(".sizeguide-table");

  tabs && tabs.forEach((tab) => tab.classList.remove("active"));
  tables && tables.forEach((table) => table.classList.remove("active"));
};

const openSizeGuideDrawer = () => {
  const sizeGuide = document.querySelector(".sizeguide-panel");
  const sizeGuideShadowBg = document.getElementById("fit-guide-shadow-bg");
  const button = document.querySelector(".fit-guide-toggle");

  button &&
    button.addEventListener("click", () => {
      sizeGuide && sizeGuide.classList.add("is-visible");
      sizeGuideShadowBg && sizeGuideShadowBg.classList.add("is-visible");
      disableDocumentScroll();
    });
};

const closeSizeGuideDrawer = () => {
  const sizeGuide = document.querySelector(".sizeguide-panel");
  const sizeGuideShadowBg = document.getElementById("fit-guide-shadow-bg");
  const toggle = document.querySelector(".fit-guide-toggle");

  sizeGuide && sizeGuide.classList.remove("is-visible");
  sizeGuideShadowBg && sizeGuideShadowBg.classList.remove("is-visible");
  toggle && toggle.classList.remove("is-active");
  enableDocumentScroll();
};

const closeSizeGuideDrawerOnShadowClick = () => {
  const sizeGuideShadowBg = document.getElementById("fit-guide-shadow-bg");

  sizeGuideShadowBg &&
    sizeGuideShadowBg.addEventListener("click", () => {
      closeSizeGuideDrawer();
    });
};

const closeSizeGuideDrawerOnButtonClick = () => {
  const button = document.getElementById("close-fit-guide");

  button &&
    button.addEventListener("click", () => {
      closeSizeGuideDrawer();
    });
};

const toggleInquiryDrawer = () => {
  const button = document.querySelector(".inquiry-toggle");
  const soldOutButton = document.getElementById("toggle-inquiry");
  const soldOutButtonVariant = document.querySelectorAll(
    ".toggle-inquiry-variant"
  );
  const shadow = document.getElementById("inquiry-shadow-bg");
  const modal = document.getElementById("inquiry-modal");

  button &&
    button.addEventListener("click", () => {
      shadow && shadow.classList.toggle("active");
      modal && modal.classList.toggle("is-visible");
      document.getElementById("inquiry-product-url").value =
        window.location.href;
      disableDocumentScroll();
    });

  soldOutButton &&
    soldOutButton.addEventListener("click", () => {
      shadow && shadow.classList.toggle("active");
      modal && modal.classList.toggle("is-visible");
      document.getElementById("inquiry-product-url").value =
        window.location.href;
      disableDocumentScroll();
    });

  soldOutButtonVariant &&
    soldOutButtonVariant.forEach(function (e) {
      e.addEventListener("click", () => {
        shadow && shadow.classList.toggle("active");
        modal && modal.classList.toggle("is-visible");
        document.getElementById("inquiry-product-url").value =
          window.location.href;
        setTimeout(() => {
          disableDocumentScroll();
        }, 400);
      });
    });
};

const closeInquiryDrawer = () => {
  const shadow = document.getElementById("inquiry-shadow-bg");
  const modal = document.getElementById("inquiry-modal");
  const button = document.querySelector(".inquiry-toggle");

  shadow && shadow.classList.remove("active");
  modal && modal.classList.remove("is-visible");
  button && button.classList.remove("is-active");
  enableDocumentScroll();
};

const closeInquiryDrawerOnButtonClick = () => {
  const button = document.getElementById("close-inquiry");

  button &&
    button.addEventListener("click", () => {
      closeInquiryDrawer();
      enableDocumentScroll();
    });
};

const closeInquiryDrawerOnShadowClick = () => {
  const shadow = document.getElementById("inquiry-shadow-bg");

  shadow &&
    shadow.addEventListener("click", () => {
      closeInquiryDrawer();
      enableDocumentScroll();
    });
};

const closeEditionZoomedLookbookOnButtonClick = () => {
  const button = document.getElementById("close-edition-fullscreen-lookbook");

  button &&
    button.addEventListener("click", () => closeEditionZoomedLookbook());
};

const closeEditionZoomedLookbook = () => {
  const lookbook = document.getElementById("edition-lookbook");
  const gallery = document.getElementById("edition-gallery");

  lookbook && lookbook.classList.remove("is-visible");

  if (gallery) {
    setTimeout(() => {
      gallery.scrollTo(0, 0);
    }, 400);
  }
};

const toggleEditionZoomLookbook = () => {
  const images = document.querySelectorAll(".edition-grid .zoom img");
  const lookbook = document.getElementById("edition-lookbook");
  const fullScreenImages = document.querySelectorAll(
    '#edition-lookbook > div > div[id*="full-screen-lookbook"]'
  );
  const gallery = document.getElementById("edition-gallery");

  images &&
    images.forEach((image, i) => {
      image.addEventListener("click", () => {
        lookbook.classList.toggle("is-visible");
        const imageId = i;

        fullScreenImages &&
          fullScreenImages.forEach((image, index) => {
            const fullScreenImageTop = image.getBoundingClientRect().top;

            if (imageId == index)
              gallery && gallery.scrollTo(0, fullScreenImageTop);
          });
      });
    });
};

const togglePDPZoomLookbook = () => {
  const images = document.querySelectorAll(".product__media-wrapper li");
  const fullScreenImages = document.querySelectorAll(
    "#edition-lookbook li img"
  );
  const gallery = document.querySelector(".product-media-modal__content");

  images &&
    images.forEach((image, i) => {
      image.addEventListener("click", () => {
        const imageId =
          image.dataset.mediaId &&
          image.dataset.mediaId.split("-")[
            image.dataset.mediaId.split("-").length - 1
          ];

        document.body.classList.add("product-modal-active");

        fullScreenImages &&
          fullScreenImages.forEach((image) => {
            const fullScreenImageTop = image.getBoundingClientRect().top;
            const fullScreenImageId = image.dataset.mediaId;

            if (imageId == fullScreenImageId)
              gallery && gallery.scrollTo(0, fullScreenImageTop);
          });
      });
    });
};

const disableEnterKeyOnPasswordInputs = () => {
  const inputs = document.querySelectorAll('input[type="password"]');

  inputs &&
    inputs.forEach((input) => () => {
      input.addEventListener("keyup", (e) => {
        const button = input.querySelector(".toggle-show-password");

        if (e.key === ENTER_KEYCODE) {
          if (button) button.preventDefault();
        }
      });
    });
};

const toggleShowPassword = () => {
  const buttons = document.querySelectorAll(".toggle-show-password");
  const inputs = document.querySelectorAll(".password-input-for-toggle");

  buttons &&
    buttons.forEach((button, i) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();

        if (button.innerText === "Show") {
          button.innerText = "Hide";
        } else {
          button.innerText = "Show";
        }

        if (inputs[i].type === "password") {
          inputs[i].type = "text";
        } else {
          inputs[i].type = "password";
        }
      });
    });
};

const showRecoverPasswordWidget = () => {
  const button = document.getElementById("recover-password");
  const recoverPasswordWidget = document.getElementById(
    "recover-password-container"
  );
  const loginWidget = document.getElementById("login-container");

  button &&
    button.addEventListener("click", () => {
      recoverPasswordWidget && recoverPasswordWidget.classList.add("active");
      loginWidget && loginWidget.classList.remove("active");
    });
};

const hideRecoverPasswordWidget = () => {
  const button = document.getElementById("back-to-login");
  const recoverPasswordWidget = document.getElementById(
    "recover-password-container"
  );
  const inputPassword = document.getElementById("CustomerPassword");
  const loginWidget = document.getElementById("login-container");

  button &&
    button.addEventListener("click", () => {
      recoverPasswordWidget && recoverPasswordWidget.classList.remove("active");
      loginWidget && loginWidget.classList.add("active");
      if (inputPassword) inputPassword.value = "";
    });
};

const closeNotifyMeModal = () => {
  const shadow = document.getElementById("shadow-bg-notify-me");
  const modal = document.querySelector(".appikon-bis-inline-form-wrapper");
  const header = document.querySelector("header");
  const pdpNav = document.querySelector(".pdp-variant-container");

  modal && modal.classList.remove("is-visible");
  modal.style.top = "100%";
  shadow && shadow.classList.remove("is-visible");
  enableDocumentScroll();

  setTimeout(() => {
    header.style.zIndex = 30;
    pdpNav.style.zIndex = 10;
  }, 200);
};

const closeNotifyMeOnCloseClick = () => {
  const title = document.querySelector(".appikon-bis-inline-form-title h3");

  title &&
    title.addEventListener("click", () => {
      closeNotifyMeModal();
    });
};

const openNotifyMeModal = () => {
  const shadow = document.getElementById("shadow-bg-notify-me");
  const button = document.getElementById("toggle-notify");
  const drawerButtons = document.querySelectorAll(".toggle-notify-mobile");
  const buttonVariant = document.querySelectorAll(".toggle-notify-variant");
  const header = document.querySelector("header");

  buttonVariant &&
    buttonVariant.forEach(function (e) {
      e.addEventListener("click", () => {
        const modal = document.getElementById(
          "appikon-bis-inline-form-wrapper"
        );
        const pdpNav = document.querySelector(".pdp-variant-container");
        const pdpNavInfo = document.querySelector(".pdp-nav .pdp-nav-info");

        const notifyMe = document.querySelector(
          ".appikon-bis-inline-form-wrapper"
        );
        const vw = window.innerWidth;

        hideFormOnNotifyMeSubmit();

        if (vw < 874) {
          if (notifyMe) {
            const container = notifyMe.querySelector(".clearfix");
            const shadow = document.querySelector("#shadow-bg-notify-me");

            if (container) {
              const PADDING_Y = 20;
              const maxHeight = container.getBoundingClientRect().height;

              if (shadow) {
                shadow.style.height = `calc(100% - ${maxHeight}px - ${
                  PADDING_Y * 2
                }px)`;
              }

              notifyMe.style.top = `calc(100% - ${maxHeight}px - ${
                PADDING_Y * 2
              }px)`;
            }
          }
        }

        if (pdpNav) {
          pdpNav.style.zIndex = -1;
        }
        if (pdpNavInfo) {
          pdpNavInfo.style.zIndex = -1;
        }
        header.style.zIndex = 20;
        closeNotifyMeOnCloseClick();
        addAnimationCustomPlaceholderToTop();
        addDataPlaceholderToNotifyMeContainer();
        disableDocumentScroll();
        setTimeout(() => {
          modal && modal.classList.add("is-visible");
          shadow && shadow.classList.add("is-visible");
        }, 0);
      });
    });

  button &&
    button.addEventListener("click", () => {
      const modal = document.getElementById("appikon-bis-inline-form-wrapper");
      const pdpNav = document.querySelector(".pdp-variant-container");
      const pdpNavInfo = document.querySelector(".pdp-nav .pdp-nav-info");

      const notifyMe = document.querySelector(
        ".appikon-bis-inline-form-wrapper"
      );
      const vw = window.innerWidth;

      hideFormOnNotifyMeSubmit();

      if (vw < 874) {
        if (notifyMe) {
          const container = notifyMe.querySelector(".clearfix");
          const shadow = document.querySelector("#shadow-bg-notify-me");

          if (container) {
            const PADDING_Y = 20;
            const maxHeight = container.getBoundingClientRect().height;

            if (shadow) {
              shadow.style.height = `calc(100% - ${maxHeight}px - ${
                PADDING_Y * 2
              }px)`;
            }

            notifyMe.style.top = `calc(100% - ${maxHeight}px - ${
              PADDING_Y * 2
            }px)`;
          }
        }
      }

      drawerButtons &&
        drawerButtons.forEach(function (e) {
          e.addEventListener("click", () => {
            const modal = document.getElementById(
              "appikon-bis-inline-form-wrapper"
            );
            const pdpNav = document.querySelector(".pdp-variant-container");
            const pdpNavInfo = document.querySelector(".pdp-nav .pdp-nav-info");

            const notifyMe = document.querySelector(
              ".appikon-bis-inline-form-wrapper"
            );
            const vw = window.innerWidth;

            hideFormOnNotifyMeSubmit();

            if (vw < 874) {
              if (notifyMe) {
                const container = notifyMe.querySelector(".clearfix");
                const shadow = document.querySelector("#shadow-bg-notify-me");

                if (container) {
                  const PADDING_Y = 20;
                  const maxHeight = container.getBoundingClientRect().height;

                  if (shadow) {
                    shadow.style.height = `calc(100% - ${maxHeight}px - ${
                      PADDING_Y * 2
                    }px)`;
                  }

                  notifyMe.style.top = `calc(100% - ${maxHeight}px - ${
                    PADDING_Y * 2
                  }px)`;
                }
              }
            }
          });
        });

      if (pdpNav) {
        pdpNav.style.zIndex = -1;
      }
      if (pdpNavInfo) {
        pdpNavInfo.style.zIndex = -1;
      }
      header.style.zIndex = 20;
      closeNotifyMeOnCloseClick();
      addAnimationCustomPlaceholderToTop();
      addDataPlaceholderToNotifyMeContainer();
      disableDocumentScroll();
      setTimeout(() => {
        modal && modal.classList.add("is-visible");
        shadow && shadow.classList.add("is-visible");
      }, 0);
    });
};

const closeNotifyMeModalOnShadowClick = () => {
  const shadow = document.getElementById("shadow-bg-notify-me");
  const modal = document.querySelector(".appikon-bis-inline-form-wrapper");

  shadow &&
    shadow.addEventListener("click", () => {
      closeNotifyMeModal();
    });
};

const addDataPlaceholderToNotifyMeContainer = () => {
  const input = document.getElementById("appikon-bis-inline-form-email");
  const container = document.querySelector(".appikon-bis-inline-input-section");

  const placeholder = input && input.getAttribute("placeholder");

  if (container) container.dataset.placeholder = placeholder;
};

const hideFormOnNotifyMeSubmit = () => {
  const button = document.getElementById("appikon-bis-inline-form-submit");
  const message = document.getElementById("appikon-bis-inline-form-message");
  const form = document.getElementById("appikon-bis-inline-form");

  button &&
    button.addEventListener("click", () => {
      if (message) {
        setTimeout(() => {
          const success = message.querySelector(
            ".appikon-bis-inline-form-success"
          );

          if (success) {
            form.style.transition = "ease 300ms";
            form.style.opacity = "0";
            form.style.maxHeight = "0px";

            setTimeout(() => {
              form.style.opacity = "1";
              form.style.maxHeight = "unset";
            }, 3000);
          }
        }, 1000);
      }
    });
};

const addAnimationCustomPlaceholderToTop = () => {
  const input = document.getElementById("appikon-bis-inline-form-email");
  const container = document.querySelector(".appikon-bis-inline-input-section");

  if (input) {
    if (input.value !== "") {
      container && container.classList.add("animate-top");
    }
  }

  input &&
    input.addEventListener("focus", () => {
      container && container.classList.add("animate-top");
    });

  input &&
    input.addEventListener("blur", () => {
      if (input.value.length <= 0) {
        container && container.classList.remove("animate-top");
      }
    });
};

const showMiniCartShadowBackground = () => {
  const shadow = document.getElementById("shadow-bg-minicart");
  const button = document.querySelector(
    '#pdp-nav-add-to-cart button[type="submit"]'
  );
  const cartbutton = document.querySelector("#cart-button");
  var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();

  button &&
    button.addEventListener("click", () => {
      setTimeout(() => {
        shadow && shadow.classList.add("is-visible");
        if (windowWidth >= 874) {
          disableDocumentScroll();
        }
      }, 350);
    });

  cartbutton &&
    cartbutton.addEventListener("click", () => {
      shadow && shadow.classList.add("is-visible");
      if (windowWidth >= 874) {
        disableDocumentScroll();
      }
    });
};

const closeMiniCart = () => {
  const shadow = document.getElementById("shadow-bg-minicart");
  const minicart = document.getElementById("cart-notification");

  shadow && shadow.classList.remove("is-visible");
  minicart && minicart.classList.remove("active");
  enableDocumentScroll();
};

const closeMiniCartOnButtonClick = () => {
  const button = document.getElementById("close-minicart");

  button &&
    button.addEventListener("click", () => {
      closeMiniCart();
    });
};

const closeMiniCartMobile = () => {
  const button = document.querySelector(
    "#CartDrawer .drawer__header .drawer__close"
  );

  button &&
    button.addEventListener("click", () => {
      closeMiniCart();
    });
};

const closeMiniCartOnShadowClick = () => {
  const shadow = document.getElementById("shadow-bg-minicart");
  const cartOverlay = document.getElementById("CartDrawer-Overlay");

  shadow &&
    shadow.addEventListener("click", () => {
      closeMiniCart();
    });

  cartOverlay &&
    cartOverlay.addEventListener("click", () => {
      closeMiniCart();
    });
};

const hideAllTabsContentInAccountPage = () => {
  const tabsContent = document.querySelectorAll(".account .tab-content");

  tabsContent &&
    tabsContent.forEach((tab) => tab.classList.remove("is-active"));
};

const setAllTabsAsInactive = () => {
  const tabs = document.querySelectorAll(".tabs-header .account-tab a");

  tabs && tabs.forEach((tab) => tab.classList.remove("active"));
};

const changeTabsInAccountPage = () => {
  const tabs = document.querySelectorAll(".tabs-header .account-tab a");
  const tabsContent = document.querySelectorAll(".account .tab-content");

  tabs &&
    tabs.forEach((tab, i) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        hideAllTabsContentInAccountPage();
        setAllTabsAsInactive();
        hideAllAddressForms();

        tab.classList.add("active");
        tabsContent[i].classList.add("is-active");

        if (tab.hash === "#dashboard") {
          showDashboardAccountDetails();
          showDashboardOrders();
          showDashboardAddresses();
          showDashboardAddressesHeader();
        }

        if (tab.hash === "#addresses") {
          const newAddressForm = document.querySelector(
            "section#addresses-container .add-new-address"
          );

          newAddressForm && newAddressForm.classList.remove("is-visible");
          showAddressesListFromAddressesContent();
        }
      });
    });
};

const setCookie = (cookie) => {
  document.cookie = cookie;
};

const isCookieSet = (cookieName) => {
  const name = cookieName + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookiesArray = decodedCookie.split(";");

  for (let i = 0; i < cookiesArray.length; i++) {
    let cookie = cookiesArray[i];

    while (cookie.charAt(0) == " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) == 0) return true;
  }

  return false;
};

const hideCookiesPolicyBanner = () => {
  const cookiesBanner = document.querySelector(".cookies-notice-wrapper");

  cookiesBanner && cookiesBanner.classList.remove("is-visible");
};

const hideCookiesBannerIfAccepted = () => {
  const areCookiesAccepted = isCookieSet("acceptedCookiesPolicy");

  if (areCookiesAccepted) hideCookiesPolicyBanner();
};

const setCookieOnPolicyAccept = () => {
  const buttonAccept = document.getElementById("accept-cookies");

  buttonAccept &&
    buttonAccept.addEventListener("click", () => {
      setCookie("acceptedCookiesPolicy=true");
      hideCookiesPolicyBanner();
    });
};

const changeFirstOptionOnAddressCountrySelect = () => {
  const selectNewCountry = document.getElementById("AddressCountryNew");
  const selectEditCountries = document.querySelectorAll(
    'select[id*="AddressCountry_"]'
  );

  if (selectNewCountry) selectNewCountry.firstElementChild.text = "Country";

  selectEditCountries &&
    selectEditCountries.forEach((select) => {
      select.firstElementChild.text = "Country";
    });
};

const hideLabelIfNoCountryIsSelected = () => {
  const labels = document.querySelectorAll(".country-region label");
  const editAddressSelect = document.querySelectorAll(
    '.new-country-region select[id*="AddressCountry_"]'
  );
  const select = document.getElementById("AddressCountryNew");

  editAddressSelect &&
    editAddressSelect.forEach((select) => {
      if (select.selectedIndex === 0) {
        select
          .closest(".new-country-region")
          .children[0].classList.remove("not-active");
      } else {
        select
          .closest(".new-country-region")
          .children[0].classList.add("not-active");
      }

      select.addEventListener("change", () => {
        if (select.selectedIndex === 0) {
          select
            .closest(".new-country-region")
            .children[0].classList.add("not-active");
        } else {
          select
            .closest(".new-country-region")
            .children[0].classList.remove("not-active");
        }
      });
    });

  if (select) {
    labels &&
      labels.forEach((label) => {
        if (select.selectedIndex === 0) {
          label && label.classList.add("not-active");
        } else {
          label && label.classList.remove("not-active");
        }

        select.addEventListener("change", () => {
          if (select.selectedIndex === 0) {
            label && label.classList.add("not-active");
          } else {
            label && label.classList.remove("not-active");
          }
        });
      });
  }
};

const disableStateSelectIfNoCountryIsProvided = () => {
  const countries = document.getElementById("AddressCountryNew");
  const states = document.getElementById("AddressProvinceNew");

  if (states) states.disabled = true;

  countries &&
    countries.addEventListener("change", () => {
      if (countries.value !== "---") states.disabled = false;
      else {
        states.disabled = true;
      }
    });
};

const showAddressesListOnAccount = () => {
  const addressContainer = document.getElementById("addresses-container");
  const h1 = document.querySelector(".customer section#addresses-container h1");
  const lists = document.querySelectorAll(
    ".customer section#addresses-container .addresses-list"
  );
  const button = document.querySelector(
    ".customer section#addresses-container #open-add-address-widget"
  );

  addressContainer && addressContainer.classList.add("is-active");
  h1 && h1.classList.add("is-visible");
  lists && lists.forEach((list) => list.classList.add("is-visible"));
  button && button.classList.add("is-visible");
};

const showDashboardOnAccount = () => {
  const dashboard = document.getElementById("dashboard-container");

  hideAllTabsContentInAccountPage();

  dashboard && dashboard.classList.add("is-active");
};

const hideAllAddressForms = () => {
  const isVisibleElement = document.querySelectorAll(
    "section#dashboard-container .edit-address"
  );

  isVisibleElement &&
    isVisibleElement.forEach((element) =>
      element.classList.remove("is-visible")
    );
};

const hideAddressesContent = () => {
  const addresses = document.getElementById("addresses-container");

  addresses && addresses.classList.remove("is-active");
};

const cancelEditAddressForm = () => {
  const buttons = document.querySelectorAll(
    'section#dashboard-container button[type="cancel"]'
  );

  buttons &&
    buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        hideAllAddressForms();
        hideAllTabsContentInAccountPage();

        if (window.innerWidth >= 874) showAddressesListOnAccount();
        else {
          toggleAddNewAddressButtonIfEditionModeIsActive();
          showDashboardOnAccount();
          showDashboardAccountDetails();
          showDashboardOrders();
          showDashboardAddresses();
          showDashboardAddressesHeader();
        }
      });
    });
};

const toggleAddNewAddressButtonIfEditionModeIsActive = () => {
  const addNewButton = document.getElementById("add-new-address-mobile");
  const editAdressForm = document.querySelectorAll(
    "#dashboard-container li[data-address] .edit-address"
  );
  let shouldStopLooping = 999;

  editAdressForm &&
    editAdressForm.forEach((address, i) => {
      if (address.classList.contains("is-visible")) {
        if (shouldStopLooping > i) {
          addNewButton.setAttribute("hidden", "");
          shouldStopLooping = i;
        }
      } else {
        if (shouldStopLooping > i) {
          addNewButton.removeAttribute("hidden");
        }
      }
    });
};

const showEditAddressForm = () => {
  const addressEditButtons = document.querySelectorAll(
    'button[aria-controls*="EditAddress_"]'
  );

  addressEditButtons &&
    addressEditButtons.forEach((button) => {
      button.addEventListener("click", () => {
        hideAllAddressForms();
        showDashboardOnAccount();
        hideDashboardAccountDetails();
        hideDashboardOrders();
        hideDashboardAddresses();
        hideDashboardAddressesHeader();

        const id = button.dataset.addressId;
        const form = document.getElementById(`EditAddress_${id}`);

        form && form.classList.add("is-visible");
      });
    });
};

const hideDashboardAccountDetails = () => {
  const accountDetails = document.querySelector(
    "#dashboard-container .details-container"
  );

  accountDetails && accountDetails.classList.add("hidden");
};

const showDashboardAccountDetails = () => {
  const accountDetails = document.querySelector(
    "#dashboard-container .details-container"
  );

  accountDetails && accountDetails.classList.remove("hidden");
};

const hideDashboardOrders = () => {
  const orders = document.querySelector(
    "#dashboard-container .orders-container"
  );

  orders && orders.classList.add("hidden");
};

const showDashboardOrders = () => {
  const orders = document.querySelector(
    "#dashboard-container .orders-container"
  );

  orders && orders.classList.remove("hidden");
};

const hideDashboardAddresses = () => {
  const addresses = document.querySelectorAll(
    "#dashboard-container .address-information"
  );

  addresses && addresses.forEach((address) => address.classList.add("hidden"));
};

const showDashboardAddresses = () => {
  const addresses = document.querySelectorAll(
    "#dashboard-container .address-information"
  );

  addresses &&
    addresses.forEach((address) => address.classList.remove("hidden"));
};

const hideDashboardAddressesHeader = () => {
  const header = document.querySelector("#dashboard-container .address-header");

  header && header.classList.add("hidden");
};

const showDashboardAddressesHeader = () => {
  const header = document.querySelector("#dashboard-container .address-header");

  header && header.classList.remove("hidden");
};

const cancelNewAddressForm = () => {
  const button = document.querySelector(
    'section#addresses-container .add-new-address form button[type="reset"]'
  );
  const newAddressForm = document.querySelector(
    "section#addresses-container .add-new-address"
  );

  button &&
    button.addEventListener("click", () => {
      if (window.innerWidth >= 874) {
        newAddressForm && newAddressForm.classList.remove("is-visible");
        showAddressesListFromAddressesContent();
      } else {
        const dashboard = document.getElementById("dashboard-container");

        hideAllTabsContentInAccountPage();
        dashboard && dashboard.classList.add("is-active");
      }
    });
};

const showAddNewAddressForm = () => {
  const button = document.getElementById("open-add-address-widget");
  const form = document.querySelector(
    "section#addresses-container .add-new-address"
  );

  button &&
    button.addEventListener("click", () => {
      hideAllAddressForms();
      hideAddressesListFromAddressesContent();

      form && form.classList.add("is-visible");
    });
};

const showAddressesListFromAddressesContent = () => {
  const addressContentList = document.querySelector(
    "#addresses-container > div > ul"
  );
  const h1 = document.querySelector(".customer section#addresses-container h1");

  h1 && h1.classList.add("is-visible");
  addressContentList && addressContentList.classList.remove("hidden");
};

const hideAddressesListFromAddressesContent = () => {
  const addressContentList = document.querySelector(
    "#addresses-container > div > ul"
  );
  const h1 = document.querySelector(".customer section#addresses-container h1");

  h1 && h1.classList.remove("is-visible");
  addressContentList && addressContentList.classList.add("hidden");
};

const editAddressFromDashboard = () => {
  const buttons = document.querySelectorAll(".edit-address-from-dashboard");
  const addressesTab = document.querySelector(
    ".tabs-header .account-tab:nth-child(3) a"
  );

  buttons &&
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const id = button.dataset.addressId;
        const form = document.getElementById(`EditAddress_${id}`);

        hideAllTabsContentInAccountPage();
        setAllTabsAsInactive();
        hideAddressesContent();

        hideAllAddressForms();
        showDashboardOnAccount();
        hideDashboardAccountDetails();
        hideDashboardOrders();
        hideDashboardAddresses();
        hideDashboardAddressesHeader();

        addressesTab && addressesTab.classList.add("active");
        form && form.classList.add("is-visible");

        toggleAddNewAddressButtonIfEditionModeIsActive();
      });
    });
};

const addAddressFromDashboard = () => {
  const button = document.querySelector(
    ".customer .addresses button.add-address"
  );
  const addressesContent = document.getElementById("addresses-container");
  const addNewAddressForm = document.querySelector(
    ".customer .add-new-address"
  );
  const addressTab = document.querySelector(
    ".tabs-header .account-tab:nth-child(3) a"
  );

  button &&
    button.addEventListener("click", () => {
      hideAllTabsContentInAccountPage();
      setAllTabsAsInactive();
      hideAllAddressForms();
      hideAddressesListFromAddressesContent();

      addressesContent && addressesContent.classList.add("is-active");
      addNewAddressForm && addNewAddressForm.classList.add("is-visible");
      addressTab && addressTab.classList.add("active");
    });
};

const resetAddressesViewOnTabClick = () => {
  const addressesTab = document.querySelector(
    ".tabs-header .account-tab:nth-child(3) a"
  );
  const addresses = document.querySelectorAll(
    ".customer section#addresses-container .addresses-list"
  );
  const h1 = document.querySelector(".customer section#addresses-container h1");
  const button = document.querySelector(
    ".customer section#addresses-container #open-add-address-widget"
  );

  addressesTab &&
    addressesTab.addEventListener("click", () => {
      hideAllAddressForms();

      addresses &&
        addresses.forEach((address) => {
          address.classList.add("is-visible");
        });

      h1 && h1.classList.add("is-visible");
      button && button.classList.add("is-visible");
    });
};

const checkOnCustomCheckboxClick = () => {
  const customInputs = document.querySelectorAll(".custom-input");

  customInputs &&
    customInputs.forEach((input) => {
      input.addEventListener("click", (e) => {
        const checkbox = e.target.previousElementSibling;
        checkbox.checked = !checkbox.checked;
      });
    });
};

const backToDashboardMobile = () => {
  const buttons = document.querySelectorAll(".customer button.acc-back-button");
  const dashboard = document.getElementById("dashboard-container");

  buttons &&
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        hideAllTabsContentInAccountPage();
        hideAllAddressForms();
        showDashboardOnAccount();
        showDashboardAccountDetails();
        showDashboardOrders();
        showDashboardAddresses();
        showDashboardAddressesHeader();
        toggleAddNewAddressButtonIfEditionModeIsActive();

        dashboard && dashboard.classList.add("is-active");
      });
    });
};

const editAccountInformationOnButtonClick = () => {
  const button = document.querySelector(".edit-acc-information-btn");
  const dashboard = document.getElementById("dashboard-container");
  const accInformation = document.getElementById(
    "account-information-container"
  );
  const tab = document.querySelector(".account-tab:nth-child(2) a");

  button &&
    button.addEventListener("click", () => {
      dashboard && dashboard.classList.remove("is-active");
      accInformation && accInformation.classList.add("is-active");

      setAllTabsAsInactive();
      tab && tab.classList.add("active");
    });
};

const editAccountDetailsMobile = () => {
  const button = document.getElementById("edit-account-details-mobile");
  const accountDetails = document.getElementById(
    "account-information-container"
  );

  button &&
    button.addEventListener("click", () => {
      hideAllTabsContentInAccountPage();

      accountDetails && accountDetails.classList.add("is-active");
    });
};

const addAddressFromDashboardMobile = () => {
  const button = document.getElementById("add-new-address-mobile");
  const addressesContent = document.getElementById("addresses-container");
  const addNewAddressForm = document.querySelector(
    ".customer .add-new-address"
  );
  const addressTab = document.querySelector(
    ".tabs-header .account-tab:nth-child(3) a"
  );

  button &&
    button.addEventListener("click", () => {
      hideAllTabsContentInAccountPage();
      setAllTabsAsInactive();
      hideAllAddressForms();
      hideAddressesListFromAddressesContent();

      addressesContent && addressesContent.classList.add("is-active");
      addNewAddressForm && addNewAddressForm.classList.add("is-visible");
      addressTab && addressTab.classList.add("active");
    });
};

const toggleFitGuideUnits = () => {
  const units = document.querySelectorAll("#measurements-units-toggle button");
  const tables = document.querySelectorAll(".measurements-tables");

  units &&
    units.forEach((unit) => {
      unit.addEventListener("click", () => {
        units.forEach((_unit) => _unit.classList.remove("active"));
        unit.classList.add("active");

        if (unit.classList.contains("inches")) {
          tables.forEach((_table) => _table.classList.remove("active"));

          tables &&
            tables.forEach((table) => {
              if (table.classList.contains("cm-inches")) {
                table.classList.add("active");
              }
            });
        } else if (unit.classList.contains("cm")) {
          tables.forEach((_table) => _table.classList.remove("active"));

          tables &&
            tables.forEach((table) => {
              if (table.classList.contains("cm-body")) {
                table.classList.add("active");
              }
            });
        }
      });
    });
};

const setActiveColorSwatch = () => {
  const colorOptions = document.querySelectorAll(
    '.pdp-variant-container .pdp-variant:nth-child(1) fieldset input[type="radio"]'
  );
  const variantOption = document.querySelector(
    ".pdp-variant-container .pdp-variant:nth-child(1) > .variant-option-color"
  );

  colorOptions &&
    colorOptions.forEach((option) => {
      if (
        option.checked &&
        option.hasAttribute("data-colorway") &&
        variantOption
      ) {
        const swatch = option.nextElementSibling?.children[0];
        if (swatch) {
          const clonedSwatch = swatch.cloneNode(true);
          clonedSwatch.classList.add("cloned-swatch");

          variantOption.appendChild(clonedSwatch);
        }
      }

      option.addEventListener("change", (e) => {
        if (option.checked && variantOption) {
          const swatch = e.target.nextElementSibling?.children[0];
          if (swatch) {
            const clonedSwatch = swatch.cloneNode(true);
            clonedSwatch.classList.add("cloned-swatch");
            if (variantOption.children[2]?.classList.contains("cloned-swatch"))
              variantOption.children[2].remove();

            variantOption.appendChild(clonedSwatch);
          }
        }
      });
    });
};

const closeSuccessMessage = () => {
  const successModal = document.getElementById("success-message-modal");
  const successShadow = document.getElementById("success-message-shadow");

  successModal && successModal.classList.remove("active");
  successShadow && successShadow.classList.remove("active");
};

const closeSuccessMessageOnShadowClick = () => {
  const successShadow = document.getElementById("success-message-shadow");

  successShadow &&
    successShadow.addEventListener("click", () => {
      closeSuccessMessage();
    });
};

const closeSuccessMessageOnButtonClick = () => {
  const button = document.getElementById("close-success-message");

  button &&
    button.addEventListener("click", () => {
      closeSuccessMessage();
    });
};

const toggleSuccessMessage = () => {
  const successModal = document.getElementById("success-message-modal");
  const successShadow = document.getElementById("success-message-shadow");

  const urlParams = new URLSearchParams(window.location.search);
  const contactParam = urlParams.get("contact_posted");
  const newsletterParam = urlParams.get("customer_posted");
  const isContactPosted = contactParam === "true";
  const isNewsletterSubscribed = newsletterParam === "true";

  if (isContactPosted || isNewsletterSubscribed)
    successModal && successModal.classList.add("active");
  if (isContactPosted || isNewsletterSubscribed)
    successShadow && successShadow.classList.add("active");

  setTimeout(() => {
    closeSuccessMessage();
  }, 3000);
};

const blurTextOnHeaderEnter = () => {
  const bluredText = document.querySelectorAll(".hidden-text");
  const header = document.getElementById("header");
  const HEADER_HEIGHT = window.innerWidth >= 874 ? 135 : 55;

  bluredText &&
    bluredText.forEach((element) => {
      document.addEventListener("scroll", () => {
        const isHeaderPinned = Array.from(header.classList).includes(
          "headroom--pinned"
        );

        const distanceToTop = element.getBoundingClientRect().top;
        const opacityValue = distanceToTop / HEADER_HEIGHT;

        if (distanceToTop <= HEADER_HEIGHT && isHeaderPinned) {
          element.style.opacity = opacityValue;
        } else {
          element.style.opacity = 1;
        }
      });
    });
};

const hadBreakToArticleTitle = () => {
  const articleTitles = document.querySelectorAll(".article-title");

  articleTitles &&
    articleTitles.forEach((articleTitle) => {
      const split = articleTitle.innerText.split(":");
      const type = split[0];
      const title = split[1] === undefined ? "" : split[1];

      articleTitle.innerHTML = `<h5 class="text-32-28-22 article-title">${
        type && type.trim()
      }:<br><p>${title.trim()} <span class="inline-block ml-4 arrow relative left-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="14" viewBox="0 0 12.658 7.367">
                <path data-name="Line 29828" transform="translate(0 3.699)" style="fill: none; stroke: #000" d="M0 0h11.963" />
                <path
                    data-name="Path 25952"
                    d="m-18696.926-22264.932 3.33 3.33-3.33 3.33"
                    transform="translate(18705.547 22265.285)"
                    style="fill: none; stroke: #000"
                />
            </svg>
        </span></p>
            </h5>`;
    });
};

const adjustHeightForSafariBottomBar = () => {
  let vh = window.innerHeight * 0.01;
  let footer_height = document.getElementById("shopify-section-footer");

  document.documentElement.style.setProperty("--vh", `${vh}px`);
  footer_height &&
    document.documentElement.style.setProperty(
      "--footer-height",
      footer_height.offsetHeight + "px"
    );
};

const setTextMaxWidthBasedOnImageWidth = () => {
  const texts = document.querySelectorAll("div.three-slots-content");

  texts &&
    texts.forEach((text) => {
      const image = text && text.parentElement.firstElementChild;

      setTimeout(() => {
        const maxWidth = image && image.getBoundingClientRect().width;
        text.style.maxWidth = `${maxWidth}px`;
      }, 700);
    });
};

const resizeNotifyMeModal = () => {
  const notifyMe = document.querySelector(".appikon-bis-inline-form-wrapper");
  const vw = window.innerWidth;

  if (vw < 874) {
    if (notifyMe) {
      const container = notifyMe.querySelector(".clearfix");
      const shadow = document.querySelector("#shadow-bg-notify-me");

      if (container) {
        const PADDING_Y = 20;
        const maxHeight = container.getBoundingClientRect().height;
        const notifyMeActive = document.querySelector(
          ".appikon-bis-inline-form-wrapper.is-visible"
        );

        if (shadow) {
          shadow.style.height = `calc(100% - ${maxHeight}px - ${
            PADDING_Y * 2
          }px)`;
        }

        if (notifyMeActive) {
          notifyMeActive.style.top = `calc(100% - ${maxHeight}px - ${
            PADDING_Y * 2
          }px)`;
        }
      }
    }
  }
};

const submitFormOnClick = () => {
  const arrow = document.getElementById("search-submit");

  arrow &&
    arrow.addEventListener("click", () => {
      const form = arrow.closest("form");

      form.submit();
    });
};

const ignoreFirstHoverState = () => {
  const shopLink = document.getElementById("shop");
  // const isInShopPage = window.location.pathname.split('/')[1].includes('collections')

  shopLink && shopLink.classList.add("no-hover");

  setTimeout(() => {
    shopLink && shopLink.classList.remove("no-hover");
  }, 1350);
};

const playAllVideos = () => {
  const videos = document.querySelectorAll("video");

  videos && videos.forEach((video) => video.play());
};

const videoMuteClick = () => {
  const video_btn = document.getElementById("video-btn");
  const video_btn_mute = document.querySelectorAll("#video-btn svg");
  const videos = document.querySelectorAll(".homepage-banner video");

  video_btn &&
    video_btn.addEventListener("click", () => {
      videos.forEach((video) => {
        if (video.muted === false) {
          video.muted = true;
          video_btn_mute[0].classList.add("muted");
        } else {
          video.muted = false;
          video_btn_mute[0].classList.remove("muted");
        }
      });
    });
};

const countFiltersOnMobile = () => {
  const closeButton = document.getElementById("close-filter-mobile");

  closeButton &&
    addEventListener("click", () => {
      const selectedFilters = document.querySelectorAll(
        ".active-facets__button-inner"
      ).length;

      const counter = document.getElementById("filters-active-count");

      if (selectedFilters > 0) {
        counter.innerHTML = "(" + selectedFilters / 2 + ")";
      }
    });
};

const backToTopButton = () => {
  const backToTopButton = document.querySelector(
    '[data-component="back-to-top"]'
  );

  if (backToTopButton) {
    backToTopButton.addEventListener("click", (e) => {
      gsap.to(window, { duration: 1, scrollTo: { y: 0 }, ease: "power4" });
    });

    ScrollTrigger.create({
      trigger: document.body,
      start: "1000px top",
      markers: false,
      onToggle: () => {
        backToTopButton.classList.toggle("visible");
      },
    });
  }
};

const backToTopCheck = () => {
  const mainElement = document.querySelector("main");
  const mainElementTop =
    mainElement && mainElement.getBoundingClientRect().bottom;
  const backToTopBtn = document.querySelector('[data-component="back-to-top"]');

  if (window.innerHeight > mainElementTop) {
    backToTopBtn && backToTopBtn.classList.remove("fixed", "bottom-auto");
    backToTopBtn &&
      backToTopBtn.classList.add("absolute", "top-auto", "bottom-0");
  } else if (window.innerHeight < mainElementTop) {
    backToTopBtn &&
      backToTopBtn.classList.remove("absolute", "top-auto", "bottom-0");
    backToTopBtn && backToTopBtn.classList.add("fixed", "bottom-auto");
  }
};

const loadCorrectVideoSrc = () => {
  const video = document.querySelectorAll("video");

  function addSourceToVideo(element, src) {
    var source = document.createElement("source");
    source.src = src;
    source.type = "video/mp4";
    element.appendChild(source);
  }

  //determine screen size and select mobile or desktop vid
  function whichSizeVideo(element, src) {
    var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
    if (windowWidth >= 874) {
      addSourceToVideo(element, src.dataset.desktopVid);
    } else if (windowWidth >= 640) {
      addSourceToVideo(element, src.dataset.tabletVid);
    } else if (windowWidth <= 640) {
      addSourceToVideo(element, src.dataset.mobileVid);
    }
  }

  //init only if page has videos
  function videoSize() {
    if (video !== undefined) {
      video.forEach(function (element, index) {
        whichSizeVideo(
          element, //element
          element //src locations
        );
      });
    }
  }
  videoSize();
};

const recommendedProducts = () => {
  const container = document.querySelector(".product__recommends");

  !container ||
    fetch(
      `${container.dataset.url}?section_id=recommends&limit=6&product_id=${container.dataset.productId}`
    )
      .then((response) => response.text())
      .then((response) => {
        container.innerHTML = response;
        lazyLoadInstance.update();
      });
};

const productSlider = () => {
  const containers = document.querySelectorAll(".product-swiper");

  const initOrDestroy = () => {
    const isMobile = window.innerWidth < 768;
    containers.forEach((container) => {
      if (!container) return;

      const existing = container._swiperInstance;
      if (isMobile && !existing) {
        const wrapper = container.querySelector(".swiper-wrapper");
        const slides = wrapper ? wrapper.querySelectorAll(".swiper-slide") : [];
        if (!wrapper || !slides || slides.length <= 1) return;

        let paginationEl = container.querySelector(".swiper-pagination");
        if (!paginationEl) {
          paginationEl = document.createElement("div");
          paginationEl.className = "swiper-pagination";
          container.appendChild(paginationEl);
        }

        const instance = new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          allowTouchMove: true,
          grabCursor: true,
          watchOverflow: true,
          width: window.innerWidth, // Set explicit width to viewport
          height: null, // Let Swiper calculate height
          autoHeight: true,

          pagination: { el: paginationEl, clickable: true },
          on: {
            init: function () {
              this.slides.forEach((slide, index) => {});

              // Force height update after initialization
              setTimeout(() => {
                this.updateSize();
                this.updateSlidesClasses();
              }, 100);

              // Additional height update after images load
              const images = container.querySelectorAll("img");
              if (images.length > 0) {
                Promise.all(
                  Array.from(images).map((img) => {
                    if (img.complete) return Promise.resolve();
                    return new Promise((resolve) => {
                      img.onload = resolve;
                      img.onerror = resolve;
                    });
                  })
                ).then(() => {
                  setTimeout(() => {
                    this.updateSize();
                  }, 50);
                });
              }
            },
            resize: function () {},
            slideChange: function () {
              // Update height when slides change
              this.updateSize();
            },
            imagesReady: function () {
              // Update height when images are ready
              this.updateSize();
            },
          },
        });
        container._swiperInstance = instance;
        container.setAttribute("data-swiper-initialized", "true");
      } else if (!isMobile && existing) {
        existing.destroy(true, true);
        container._swiperInstance = null;
        container.removeAttribute("data-swiper-initialized");
      }
    });
  };

  if (containers.length) {
    initOrDestroy();
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initOrDestroy, 150);
    });
  }
};

// Add this to your theme.liquid or other main layout file
// const KLAVIYO_COMPANY_ID = "VX2Ysa";

const KlaviyoNotify = (email, productId, variantId) => {
  const form = document.getElementById("bis-form");
  const successMessage = document.getElementById("bis-success");
  const errorMessage = document.getElementById("bis-error");

  const button = form.querySelector("button");
  button.disabled = true;
  button.textContent = "Subscribing...";

  const payload = {
    data: {
      type: "back-in-stock-subscription",
      attributes: {
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: email,
            },
          },
        },
        channels: ["EMAIL"],
      },
      relationships: {
        variant: {
          data: {
            type: "catalog-variant",
            id: `$shopify:::$default:::${variantId}`,
          },
        },
      },
    },
  };

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      revision: "2024-06-15",
    },
    body: JSON.stringify(payload),
  };

  fetch(
    "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VX2Ysa",
    requestOptions
  )
    .then((result) => {
      // Hide form and show success message
      form.style.display = "none";
      successMessage.classList.remove("hidden");
      errorMessage.classList.add("hidden");
    })
    .catch((error) => {
      console.error("Subscription error:", error);
      errorMessage.classList.remove("hidden");
      successMessage.classList.add("hidden");
      errorMessage.textContent = error.message;
    })
    .finally(() => {
      const button = form.querySelector("button");
      button.disabled = false;
      button.textContent = "Notify Me When Available";
    });
};

// Initialize the Back in Stock functionality
document.addEventListener("DOMContentLoaded", function () {
  const bisContainer = document.getElementById("back-in-stock-block");

  if (!bisContainer) return;

  const productId = bisContainer.dataset.productId;
  const variantId = bisContainer.dataset.variantId;

  // Create and inject the BIS form
  const bisForm = `
    <div class="bis-form">
      <form id="bis-form" class="bis-form">
        <div class="custom-field">
          <input 
            type="email" 
            id="bis-email" 
            name="email" 
            placeholder=" "
            required
          >
          <label for="bis-email">Email Address</label>
        </div>
        <button type="submit" class="button button--primary">
          Notify Me When Available
        </button>
      </form>
      <div id="bis-success" class="hidden mt-4 text-green-600">
        Thanks! We'll let you know when this item is back in stock.
      </div>
      <div id="bis-error" class="hidden mt-4 text-red-600">
        There was an error subscribing to notifications. Please try again.
      </div>
    </div>
  `;

  bisContainer.innerHTML = bisForm;

  const form = document.getElementById("bis-form");

  // Handle form submission
  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const email = document.getElementById("bis-email").value;
    const currentVariantId = bisContainer.dataset.variantId;

    // Log submission attempt
    console.log("Attempting subscription with:", {
      email,
      productId,
      variantId: currentVariantId,
    });

    KlaviyoNotify(email, productId, currentVariantId);
  });

  // Helper function to find the currently selected variant
  function findSelectedVariant() {
    const variantJson = JSON.parse(
      document.querySelector('variant-radios script[type="application/json"]')
        .textContent
    );
    const selectedColor = document.querySelector(
      'input[type="radio"][name="Color"]:checked'
    )?.value;
    const selectedSize = document.querySelector(
      'input[type="radio"][name="Size"]:checked'
    )?.value;

    return variantJson.find(
      (variant) =>
        variant.option1 === selectedColor && variant.option2 === selectedSize
    );
  }

  // Helper function to update BIS form visibility
  function updateBISVisibility(isAvailable) {
    const addToCartButton = document.querySelector(".product-form__submit");
    const bisContainer = document.getElementById("back-in-stock-block");

    if (!bisContainer || !addToCartButton) return;

    // Force immediate style updates
    if (isAvailable) {
      bisContainer.style.cssText = "display: none !important";
      addToCartButton.style.cssText = "display: block !important";
    } else {
      addToCartButton.style.cssText = "display: none !important";
      bisContainer.style.cssText = "display: block !important";
    }
  }

  // Helper function to initialize size variant visual state
  function initializeSizeVariantState() {
    const checkedSizeInput = document.querySelector(
      'input[type="radio"][name="Size"]:checked'
    );
    if (checkedSizeInput) {
      // Remove current-variant class from all size labels
      const allSizeLabels = document.querySelectorAll(".size-variant-label");
      allSizeLabels.forEach((label) =>
        label.classList.remove("current-variant")
      );

      // Add current-variant class to the checked size label
      checkedSizeInput.nextElementSibling.classList.add("current-variant");
    }
  }

  // Watch for variant changes via the variant:changed event
  let updateTimeout;
  document.addEventListener("variant:changed", function (event) {
    if (updateTimeout) clearTimeout(updateTimeout);

    const variant = event.detail.variant;
    if (!variant) return;

    updateTimeout = setTimeout(() => {
      const bisContainer = document.getElementById("back-in-stock-block");
      if (bisContainer) {
        bisContainer.dataset.variantId = variant.id;
      }
      updateBISVisibility(variant.available);
    }, 50);
  });

  // Watch for changes in the size variant dropdown
  const sizeVariantInputs = document.querySelectorAll(
    'input[type="radio"][name="Size"]'
  );
  sizeVariantInputs.forEach((input) => {
    input.addEventListener("change", function () {
      // Clear any pending updates
      if (updateTimeout) clearTimeout(updateTimeout);

      updateTimeout = setTimeout(() => {
        const selectedVariant = findSelectedVariant();
        if (selectedVariant) {
          const bisContainer = document.getElementById("back-in-stock-block");
          if (bisContainer) {
            bisContainer.dataset.variantId = selectedVariant.id;
          }
          updateBISVisibility(selectedVariant.available);
        }
      }, 50); // Small delay to ensure DOM is ready
    });
  });

  // Initial visibility check
  const initialVariant = findSelectedVariant();
  if (initialVariant) {
    updateBISVisibility(initialVariant.available);
  }

  // Initialize size variant visual state
  initializeSizeVariantState();

  // Watch for color variant changes too
  const colorVariantInputs = document.querySelectorAll(
    'input[type="radio"][name="Color"]'
  );
  colorVariantInputs.forEach((input) => {
    input.addEventListener("change", function () {
      if (updateTimeout) clearTimeout(updateTimeout);

      updateTimeout = setTimeout(() => {
        const selectedVariant = findSelectedVariant();
        if (selectedVariant) {
          const bisContainer = document.getElementById("back-in-stock-block");
          if (bisContainer) {
            bisContainer.dataset.variantId = selectedVariant.id;
          }
          updateBISVisibility(selectedVariant.available);
        }
      }, 50);
    });
  });
});

window.addEventListener("DOMContentLoaded", (event) => {
  loadCorrectVideoSrc();
  initLazyLoading();
  // editionsNavigation();
  initHomepageSwiper();
  initAccordion();
  initHomepageLoader();
  toggleMenu();
  editionsSubMenuClick();
  editionSubMenuBackClick();
  toggleMobileShopAllMenu();
  // toggleMobileEditionsMenu();
  toggleMobileCollectionsMenu();
  openSearchInput();
  blurTextOnHeaderEnter();
  toggleFilters();
  toggleSort();
  toggleCat();
  closeOnShadowClick();
  closeFiltersOnCloseClick();
  closeSortOnCloseClick();
  closeCatOnCloseClick();
  toggleFacetsAccordion();
  applySortOnButtonClick();
  applyCatOnButtonClick();
  applyFiltersOnButtonClick();
  sortListing();
  activeLegalTab();
  checkNewsletterClosed();
  openNewsletterModal();
  closeNewsLetterOnCloseClick();
  setLegendFromProductVariantSelected();
  setLegendFromProductVariantSelectedGift();
  toggleVariantOptionsMenu();
  openProductMediaModal();
  closeProductMediaModalOnButtonClick();
  closeVariantsOnShadowClick();
  closeVariantsOnButtonClick();
  toggleSizeGuideTable();
  openSizeGuideDrawer();
  closeSizeGuideDrawerOnShadowClick();
  closeSizeGuideDrawerOnButtonClick();
  toggleInquiryDrawer();
  closeInquiryDrawerOnButtonClick();
  closeInquiryDrawerOnShadowClick();
  closeEditionZoomedLookbookOnButtonClick();
  toggleEditionZoomLookbook();
  toggleShowPassword();
  showRecoverPasswordWidget();
  hideRecoverPasswordWidget();
  openFiltersIfQueryHasFopen();
  openNotifyMeModal();
  closeNotifyMeModalOnShadowClick();
  showMiniCartShadowBackground();
  closeMiniCartOnShadowClick();
  closeMiniCartOnButtonClick();
  changeTabsInAccountPage();
  setCookieOnPolicyAccept();
  changeFirstOptionOnAddressCountrySelect();
  disableStateSelectIfNoCountryIsProvided();
  showEditAddressForm();
  cancelEditAddressForm();
  showAddNewAddressForm();
  checkOnCustomCheckboxClick();
  editAddressFromDashboard();
  addAddressFromDashboard();
  resetAddressesViewOnTabClick();
  editAccountDetailsMobile();
  backToDashboardMobile();
  addAddressFromDashboardMobile();
  toggleFitGuideUnits();
  initPlyrForMainArticle();
  setActiveColorSwatch();
  toggleSuccessMessage();
  closeSuccessMessageOnShadowClick();
  closeSuccessMessageOnButtonClick();
  cancelNewAddressForm();
  closeVariantOptionsMenuIfOptionIsSelected();
  closeVariantOptionsMenuOnOutClick();
  closeMiniCartMobile();
  hadBreakToArticleTitle();
  adjustHeightForSafariBottomBar();
  setTextMaxWidthBasedOnImageWidth();
  editAccountInformationOnButtonClick();
  flashMessageForNewsletterSubscription();
  disableEnterKeyOnPasswordInputs();
  resizeNotifyMeModal();
  addToBagFromVariantSelector();
  countFiltersOnMobile();
  hideLabelIfNoCountryIsSelected();
  removeDefaultFontFamily();
  togglePDPZoomLookbook();
  closeShadow();
  submitFormOnClick();
  ignoreFirstHoverState();
  playAllVideos();
  videoMuteClick();
  recommendedProducts();
  productSlider();
});

window.addEventListener("load", () => {
  hideCookiesBannerIfAccepted();
  backToTopButton();
});

$(function () {
  $("#create_customer").on("submit", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (
      $('input[name="customer[password]"]').val() !=
      $('input[name="customer[password_confirmation]"]').val()
    ) {
      e.preventDefault();
      window.location.href = window.location.href + "?error=matchpasswords";
    } else {
      this.submit();
    }
  });

  if (window.location.href.includes("register")) {
    if (window.location.search == "?error=matchpasswords") {
      const errorSpan = document.querySelector(".register-error");
      errorSpan.innerHTML = "The provided passwords don't match";

      $(".register-error").show();
      setTimeout(() => {
        $(".register-error").hide();
      }, 5000);
    }
  }
});

window.addEventListener("resize", () => {
  adjustHeightForSafariBottomBar();
  setTextMaxWidthBasedOnImageWidth();
  resizeNotifyMeModal();
});

// ON DOCUMENT KEY PRESS EVENTS
document.addEventListener("keydown", (e) => {
  if (e.key == ESCAPE_KEYCODE) {
    closeSearchInput();
    closeNewsletterModal();
    closeProductMediaModal();
    closeEditionZoomedLookbook();
    closeInquiryDrawer();
    closeSizeGuideDrawer();
    closeNotifyMeModal();
    closeMiniCart();
  }
});

// ON DOCUMENT SCROLL EVENT
window.addEventListener("scroll", () => {
  // headerSwitch();
  closeVariantOptionsMenu();
  checkIfPdpNavAsReachedBottom();
  hpBannerCheck();
  backToTopCheck();
  checkNewsletterClosed();
});

// ON DOCUMENT CLICK EVENT
document.addEventListener("click", (e) => {
  const variants = document.querySelectorAll(".pdp-variant");
  let vw = window.innerWidth;

  if (isMenuOpen) {
    if (e.target.id !== "search" && e.target.id !== "search-input") {
      closeSearchInput();
    }
  }

  if (isNewsletterModalOpen) {
    if (e.target.id === "newsletter-shadow-bg") {
      closeNewsletterModal();
    }
  }

  variants &&
    variants.forEach((variant) => {
      if (variant.classList.contains("active")) {
        if (
          e.target.nodeName.toLowerCase() !== "label" &&
          !e.target.classList.contains("variant-option")
        ) {
          if (vw > 768) closeVariantOptionsMenu();
        }
      }
    });
});

$(function () {
  // alert("ready");
  if ($(".collection-gallery").length > 0) {
    $(".collection-gallery").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      dots: false,
      speed: 150,
    });

    $(".next-button").click(function () {
      $(".collection-gallery").slick("slickNext");
    });

    $(".lookbook-item").click(function () {
      $(".collection-gallery").slick("slickNext");
    });

    $(".prev-button").click(function () {
      $(".collection-gallery").slick("slickPrev");
    });

    // provide a real index to each collection item
    $(".zoom").each(function (index) {
      $(this).attr("data-index", index);
    });

    // go to the appropriate gallery item when clicking a collection item
    $(".zoom").click(function () {
      const index = $(this).attr("data-index");
      // $('#edition-lookbook').addClass('active');
      $(".collection-gallery").slick("slickGoTo", index);
    });

    $(document).on("keydown", function (event) {
      if ($("#edition-lookbook").hasClass("is-visible")) {
        if (event.which === 27) {
          // Code to execute when the Escape key is pressed
          $("#edition-lookbook").removeClass("is-visible");
        }

        if (event.which === 39) {
          // Code to execute when the right arrow key is pressed
          $(".collection-gallery").slick("slickNext");
        }

        if (event.which === 37) {
          // Code to execute when the left arrow key is pressed
          $(".collection-gallery").slick("slickPrev");
        }
      }
    });
  }
  // original panel open code, isense changed their code so this no longer works
  // $(".cookie-panel-btn").on("click", function () {
  //   $(".cc-settings-view")
  //     .css({ display: "block" })
  //     .removeClass("hide-isense")
  //     .addClass("show-isense");
  // });

  // showing the panel via the parent div, which is the new way they control the showing of the panel, this doesn't work for some reason
  // $(".cookie-panel-btn").on("click", function () {
  //   // Select the direct parent <div> of .cc-settings-view
  //   $(".cc-settings-view").parent().css({ display: "block", opacity: 1 });
  // });

  // this works but the cc-banner is not there after you've made a cookie selection, need to find the original button.
  $(".cookie-panel-btn").on("click", function () {
    // fake a click on the settings buttons from the app
    $(".cc-banner .isense-cc-settings").trigger("click");
    $(".isense-reopen-widget-text").trigger("click");
  });
});
